// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T18:11:50.327Z
// Property: Arbor Pointe (ID: 6767906449167169)
// Collections: 14 amenities, 2 floorplans (live), 20 photos, 74 POIs, 2 reviews, 2 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167169",
  "property_external_id": "1101847",
  "property_zillow_url": "https://www.zillow.com/apartments/anchorage-ak/arbor-pointe/5XydNG/",
  "property_apartments_url": "https://www.apartments.com/arbor-pointe-apartment-homes-anchorage-ak/dvh256j/",
  "property_google_business_url": "https://www.google.com/maps/place/Arbor+Pointe/data=!4m2!3m1!1s0x0:0xa952ca4d371afad5?sa=X&ved=2ahUKEwjL57P-5YOTAxWZrokEHaIjKxMQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47758582553",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "arbor-pointe",
  "property_name": "Arbor Pointe",
  "property_website_url": "https://alaska.weidner.com/apartments/ak/anchorage/arbor-pointe-6/",
  "property_domain": "https://www.arborpointeapartmenthomes.com",
  "property_address": "1473 W 25th Ave",
  "property_full_address": "1473 W 25th Ave, Anchorage, AK 99503",
  "property_address_1": "1473 W 25th Ave",
  "property_address_2": null,
  "property_address_city": "Anchorage",
  "property_address_state": "AK",
  "property_address_zip_full": null,
  "property_address_zip": "99503",
  "property_address_country": "US",
  "property_address_county": "Anchorage Municipality",
  "property_neighborhood_address": "North Star",
  "property_address_latitude": "61.1988207",
  "property_address_longitude": "-149.9124054",
  "property_email": "arborpointe@Weidner.com",
  "property_phone": "(907) 308-2998",
  "property_call_tracking_phone": "907-308-2998",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Arbor Pointe in Anchorage, AK, choose from stylish studio or one-bedroom floor plans designed for comfort and convenience. Enjoy modern amenities like energy-efficient appliances, a private patio, and access to on-site laundry and bike storage. Embrace your new lifestyle—check availability or schedule a tour today!",
  "property_long_description": "**Welcome to Arbor Pointe – Your Ideal Anchorage Retreat!**\n\nDiscover the perfect blend of comfort and convenience at Arbor Pointe, a charming apartment community nestled in the heart of Anchorage, AK. Our thoughtfully designed floor plans include stylish studios and spacious one-bedroom apartments, catering to a variety of lifestyles. Whether you’re looking for a cozy nook or a more expansive living space, you'll find the perfect match at Arbor Pointe.\n\nOur community boasts a suite of premium amenities designed to enhance your living experience. Enjoy the ease of on-site laundry facilities and a dedicated management team, always ready to assist you. For biking enthusiasts, our bike storage provides a secure place for your gear. Each apartment features energy-efficient appliances that not only reduce your utility bills but also promote a sustainable lifestyle. Step outside onto your private patio or balcony and soak in the fresh Alaskan air, or stay connected with your personal intercom for added convenience.\n\nLocated within easy access to local shops, dining, and outdoor activities, Arbor Pointe offers the ideal blend of urban living and nature's beauty. Discover your new community where comfort meets style, and every detail is designed with you in mind.\n\n**Don’t wait! Find your new home today at Arbor Pointe. Browse our availability or schedule a tour to visit our community and experience all that awaits you!**",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f45-9b09-73bb-9bed-fc275ea7f1a3.webp",
  "property_featured_image_media": {
    "alt_text": "Kitchen with white refrigerator, white stove, wooden cabinets, and orange countertops.",
    "public_id": "01a11f45-9b09-73bb-9bed-fc275ea7f1a3",
    "storage_key": "property/6767906449167169/01a11f45-9b09-73bb-9bed-fc275ea7f1a3.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "31",
  "property_year_built": "1982",
  "property_year_renovated": null,
  "property_walk_score": "82",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.32258064516128",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $1,000",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://alaska-weidner.securecafe.com/onlineleasing/arbor-pointe-6/floorplans.aspx",
  "property_resident_portal_url": "https://alaska-weidner.securecafenet.com/residentservices/arbor-pointe-6/userlogin",
  "property_apply_now_url": "https://alaska-weidner.securecafe.com/onlineleasing/arbor-pointe-6/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140ae-8051-7463-8ac1-41116c0c58d4.webp",
  "property_primary_logo_media": {
    "alt_text": "Arbor Pointe apartment homes logo",
    "public_id": "01a140ae-8051-7463-8ac1-41116c0c58d4",
    "storage_key": "property/6767906449167169/01a140ae-8051-7463-8ac1-41116c0c58d4.webp",
    "width": 131,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140ae-bd9e-72ba-b911-cca23988c407.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Love Notes logo",
    "public_id": "01a140ae-bd9e-72ba-b911-cca23988c407",
    "storage_key": "property/6767906449167169/01a140ae-bd9e-72ba-b911-cca23988c407.webp",
    "width": 131,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140ae-b1e9-77d7-bdc1-10dcb63c412a.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Love notes logo",
    "public_id": "01a140ae-b1e9-77d7-bdc1-10dcb63c412a",
    "storage_key": "property/6767906449167169/01a140ae-b1e9-77d7-bdc1-10dcb63c412a.webp",
    "width": 131,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#6b0f0f",
  "property_secondary_color": "#F2EDE4",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#1a1a1a",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 1",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "1",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": " - 420",
  "property_sqft_min": "420",
  "property_sqft_max": "420",
  "property_price_range": "865 - 1165",
  "property_price_min": "865",
  "property_price_max": "1165",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/ArborPointeApartmentHomes/",
  "property_instagram_url": "https://www.instagram.com/weidnerapartmenthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJy-o7VtiXyFYR1foaN03KUqk",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Arbor Pointe",
  "property_home_romance_title": "Experience the Charm of Your New Apartment Community Today",
  "property_home_amenities_blurb": "Welcome to Arbor Pointe in Anchorage, AK, where comfort meets convenience. Choose from stylish studio or one-bedroom apartments, complete with energy-efficient appliances, private patios, and a dedicated management team. With on-site laundry and bike storage, life here is both effortless and enjoyable. Join our vibrant community today!",
  "property_home_floorplans_blurb": "Embrace the allure of Arbor Pointe in picturesque Anchorage, AK, where comfort meets style. Our thoughtfully designed floor plans cater to your unique lifestyle, providing cozy retreats for relaxation and vibrant spaces for entertaining. Ready to find your ideal apartment home? Browse our available options today and elevate your living experience!",
  "property_home_gallery_blurb": "Welcome to Arbor Pointe in the heart of Anchorage, AK, where modern living meets comfort. Choose from our stylish studio or spacious one-bedroom floor plans. Enjoy amenities like energy-efficient appliances, private patios, and a dedicated on-site management team. Picture yourself living here—your new lifestyle awaits at Arbor Pointe!",
  "property_home_neighborhood_blurb": "At Arbor Pointe in Anchorage, indulge in a lifestyle that blends comfort with adventure. Choose from stylish studio or one-bedroom apartments, all nestled near cultural gems like the Alaska Aviation Museum, Anchorage Museum, and beautiful Kincaid Park. Elevate your living experience by embracing the vibrant community just outside your door.",
  "property_home_reviews_blurb": "At Arbor Pointe in Anchorage, AK, residents rave about the vibrant community atmosphere and top-notch amenities. One happy tenant shares, “Living here feels like home in every way,” highlighting the genuine connections formed. Curious to know more? Dive into our resident reviews to discover why Arbor Pointe is the perfect place for you!",
  "property_neighborhood_blurb": "At Arbor Pointe in Anchorage, AK, vibrant living meets cultural richness. Nestled near the Anchorage Museum, Alaska Aviation Museum, and the picturesque Kincaid Park, your new home connects you to nature and history. Embrace a lifestyle filled with adventure and community—where every day offers something unique to discover.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Arbor Pointe in Anchorage, AK, your perfect home awaits. Choose from cozy studios or spacious one-bedroom apartments, all designed with energy-efficient appliances. Enjoy on-site laundry, a dedicated management team, and private outdoor spaces. Experience the perfect blend of comfort and convenience—your new lifestyle starts here!",
  "property_applynow_blurb": "Welcome to Arbor Pointe, your ideal Anchorage retreat! Choose from stylish studio or one-bedroom layouts, featuring energy-efficient appliances and private patios. Enjoy the convenience of on-site laundry and management, bike storage, and a friendly community atmosphere. Ready to elevate your living experience? Lease online today and find your new home!",
  "property_contactus_blurb": "At Arbor Pointe in Anchorage, AK, our thoughtfully designed floor plans, including stylish studios and spacious one-bedroom options, cater to your every need. With an inviting community atmosphere and stunning surroundings, your ideal home awaits. Have questions? Contact our leasing team today to begin your journey!",
  "property_faqs_blurb": "At Arbor Pointe in Anchorage, AK, we cater to your lifestyle with thoughtfully designed studio and one-bedroom apartments. Have questions about our community? Our FAQs page is here to enlighten you on everything from amenities to floor plans, ensuring Arbor Pointe feels like home before you even move in. ",
  "property_floorplans_blurb": "At Arbor Pointe in Anchorage, AK, a variety of thoughtfully designed floor plans awaits you. From cozy studios to spacious one-bedroom apartments, each layout offers a unique blend of comfort and style. Browse our available apartment homes today and discover the perfect space that aligns with your lifestyle!",
  "property_gallery_blurb": "At Arbor Pointe in Anchorage, AK, envision your ideal lifestyle in our cozy studios and spacious one-bedroom apartments. Each home features energy-efficient appliances, a private patio, and convenient amenities like on-site laundry and bike storage. Picture yourself living here, where comfort meets convenience! Check out our photo gallery!",
  "property_interactivemap_blurb": "Welcome to Arbor Pointe in Anchorage, AK, where modern comfort meets convenience. Choose from spacious studios or one-bedroom apartments, each featuring energy-efficient appliances and private balconies. With an on-site laundry facility, dedicated management team, and bike storage, your ideal living experience awaits. Access our interactive community map to find your perfect match!",
  "property_pets_blurb": "At Arbor Pointe in Anchorage, AK, embrace a vibrant lifestyle with your furry companions! Our pet-friendly community welcomes up to two pets per home, ensuring your cats and dogs feel right at home. With nearby parks and trails, your outdoor adventures await amidst stunning Alaskan scenery.",
  "property_referafriend_blurb": "At Arbor Pointe in Anchorage, AK, we embrace community living with our diverse floor plans, including stylish studios and spacious one-bedroom apartments. Great friends make great neighbors—invite someone special to experience the charm of our vibrant community. Refer a friend today and enhance your Arbor Pointe lifestyle!",
  "property_residentaccess_blurb": "Welcome to Arbor Pointe in Anchorage, AK—where comfort meets convenience. Access your resident portal to effortlessly pay rent, schedule maintenance, and manage your home. Browse our diverse floor plans, featuring stylish studios and spacious one-bedroom apartments, designed for your ideal lifestyle. Your seamless living experience begins here!",
  "property_reviews_blurb": "At Arbor Pointe in Anchorage, AK, our residents rave about the experience, noting, \"It's a welcoming community with stunning views!\" Dive into the heartfelt testimonials that showcase our commitment to comfort and connection. See what our residents have to say about living at our community!",
  "property_created_at": "1771535462776",
  "property_scheduletour_blurb": "At Arbor Pointe in Anchorage, AK, you'll find the perfect floor plan tailored to your lifestyle, whether you choose a cozy studio or a spacious one-bedroom apartment. Schedule a tour today and hear firsthand what our residents love most about life in this vibrant community!",
  "property_thankyou_blurb": "Thank you for reaching out to Arbor Pointe in beautiful Anchorage, AK! Our diverse floor plans, including stylish studios and spacious one-bedroom apartments, are designed to suit your unique lifestyle. A dedicated team member will connect with you soon to help you find your perfect home at Arbor Pointe.",
  "property_virtualtours_blurb": "At Arbor Pointe in Anchorage, AK, life unfolds in thoughtfully designed studio and one-bedroom apartments that inspire comfort and style. Immerse yourself in our vibrant community from the comfort of your home—take a virtual tour today and envision your new lifestyle, complete with stunning views and modern amenities!",
  "property_copyright": "2026 All Rights Reserved. Arbor Pointe",
  "property_seo_title_home": "Arbor Pointe |  Apartments in Anchorage, AK",
  "property_seo_description_home": "Discover Arbor Pointe in Anchorage, AK! Enjoy energy-efficient studios and one-bedroom layouts, plus amenities for a vibrant lifestyle!",
  "property_seo_title_floorplans": "Floor Plans | Anchorage, AK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Arbor Pointe in Anchorage, AK! From cozy studios to spacious one bedrooms, browse our floor plans and embrace your new home today!",
  "property_seo_title_amenities": "Amenities | Anchorage, AK Apartments for Rent",
  "property_seo_description_amenities": "Discover comfort at Arbor Pointe, Anchorage, AK! Enjoy spacious layouts, energy-efficient appliances, and welcoming private patios. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Anchorage, AK",
  "property_seo_description_gallery": "Capture the essence of Arbor Pointe in Anchorage, AK! Picture vibrant living with energy-efficient homes, private patios, and a welcoming community.",
  "property_seo_title_virtualtours": "Virtual Tours | Arbor Pointe Apartments",
  "property_seo_description_virtualtours": "Experience Arbor Pointe in Anchorage, AK—your future home awaits! Take a virtual tour of our stylish studio and one-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Arbor Pointe Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Arbor Pointe in Anchorage, AK. Use our interactive map to explore floor plans and amenities like private balconies and bike storage!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Anchorage, AK",
  "property_seo_description_neighborhood": "Experience Arbor Pointe in Anchorage! Explore local gems and attractions, and embrace a vibrant lifestyle right outside your door!",
  "property_seo_title_contact": "Contact Us | Arbor Pointe",
  "property_seo_description_contact": "Connect with Arbor Pointe in Anchorage, AK! From stylish studios to cozy one-bedroom apartments, our leasing team is ready to assist you. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Anchorage, AK",
  "property_seo_description_faqs": "Find answers about Arbor Pointe in Anchorage, AK! Check our FAQs for insights on floor plans, amenities, and more. Your ideal apartment awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Anchorage, AK",
  "property_seo_description_reviews": "At Arbor Pointe in Anchorage, AK, our residents share their experiences of comfort, energy-efficient living, and community vibes. See their reviews today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Anchorage, AK",
  "property_seo_description_applynow": "Welcome to Arbor Pointe in Anchorage, AK! Choose from cozy studios to spacious one-bedrooms. Enjoy top amenities and apply online for your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Arbor Pointe",
  "property_seo_description_residentaccess": "Access Arbor Pointe's resident portal for easy rent payments, maintenance requests, and community updates in beautiful Anchorage, AK!",
  "property_seo_title_referafriend": "Refer A Friend | Arbor Pointe",
  "property_seo_description_referafriend": "Refer a friend to Arbor Pointe in Anchorage, AK! Great friends make the best neighbors. Share the joy of community living—start the referral today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Arbor Pointe",
  "property_seo_description_scheduletour": "Experience the charm of Arbor Pointe in Anchorage, AK. Schedule a tour today and uncover your future home surrounded by nature's beauty!",
  "property_seo_title_privacy": "Privacy Policy | Arbor Pointe",
  "property_seo_description_privacy": "At Arbor Pointe in Anchorage, AK, your privacy matters. Read our policy to understand how we protect your data and ensure a secure living environment.",
  "property_seo_title_accessibility": "Website Accessibility | Arbor Pointe",
  "property_seo_description_accessibility": "At Arbor Pointe in Anchorage, AK, we embrace accessibility for all. Our commitment to digital inclusion ensures everyone feels at home. Experience it with us!",
  "property_seo_title_sitemap": "Sitemap | Arbor Pointe",
  "property_seo_description_sitemap": "Navigate through Arbor Pointe’s unique offerings in Anchorage, AK. Find your perfect home today by checking out our user-friendly sitemap!",
  "property_seo_title_thankyou": "Thank You | Arbor Pointe",
  "property_seo_description_thankyou": "Thank you for reaching out to Arbor Pointe in Anchorage, AK! A team member will connect with you soon to help you find your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Anchorage, AK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793044436214",
  "amenities": [
    {
      "id": "ec_cd6ac11fc9b8852e8d8663a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "external_id": "87456145",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b50c4cdefd786e980d09dca1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "external_id": "87456146",
      "title": "Bike Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_550d670701912345cd1198f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "external_id": "87456147",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "Key Access",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c34bf5656ca21016f4c73fde",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "external_id": "87456148",
      "title": "Laundry Room/Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c384920e54457b2c770540d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "external_id": "87456150",
      "title": "Bilingual Leasing Team Members",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_221dce2c7b920d4e78c19b37",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "external_id": "87456151",
      "title": "Online Payments & Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5191cff177655c6995af8207",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "external_id": "87456152",
      "title": "Planned Social Activities/ Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c3aecade25c346f373f6486",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "external_id": "124799783",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8eff86883ccaf49177cffbf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "external_id": "87456154",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a12473-df2f-749c-8466-288f2486730b.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with orange countertops and wooden cabinets, open to living area with large window.",
        "public_id": "01a12473-df2f-749c-8466-288f2486730b",
        "storage_key": "property/6767906449167169/01a12473-df2f-749c-8466-288f2486730b.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Arbor Pointe Apartments - Kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_02dc0e088336de6c956b56dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "external_id": "87456156",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2436729bd2497fcda2328ba3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "external_id": "87456153",
      "title": "Intercom/ Call Box",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18dcb51d74d75ad921a5ff63",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "external_id": "87456158",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67e628b1accbf568901e918f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "external_id": "87456159",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51f44825f1c86094d55c022a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "external_id": "87456160",
      "title": "Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_6906c66533efe537a4a55be8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f45-9b09-73bb-9bed-fc275ea7f1a3.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, white stove, wooden cabinets, and orange countertops.",
        "public_id": "01a11f45-9b09-73bb-9bed-fc275ea7f1a3",
        "storage_key": "property/6767906449167169/01a11f45-9b09-73bb-9bed-fc275ea7f1a3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring a white refrigerator, white stove, ample wooden cabinetry, and vibrant orange countertops.",
      "link": "false",
      "alt_text": "Kitchen with white refrigerator, white stove, wooden cabinets, and orange countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (39).JPG"
    },
    {
      "id": "ec_02c39ac0b4042591eb362ab5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f45-c273-739f-92c2-f3e656417750.webp",
      "image_media": {
        "alt_text": "Kitchen area with wood cabinets, orange countertops, and a sink, opens to a living room.",
        "public_id": "01a11f45-c273-739f-92c2-f3e656417750",
        "storage_key": "property/6767906449167169/01a11f45-c273-739f-92c2-f3e656417750.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A functional kitchen space featuring warm wood cabinetry, vibrant orange countertops, and a double sink. This area flows seamlessly into the adjacent living space, offering an open-concept feel.",
      "link": "false",
      "alt_text": "Kitchen area with wood cabinets, orange countertops, and a sink, opens to a living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (36).JPG"
    },
    {
      "id": "ec_ee6741309b49ad9c22220380",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f45-e0c3-7596-9c23-13266b733615.webp",
      "image_media": {
        "alt_text": "Kitchen area with orange counter and wooden cabinets, white refrigerator and stove.",
        "public_id": "01a11f45-e0c3-7596-9c23-13266b733615",
        "storage_key": "property/6767906449167169/01a11f45-e0c3-7596-9c23-13266b733615.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore this apartment's kitchen featuring a vibrant orange breakfast bar, ample cabinet space, and modern appliances, perfect for your culinary adventures.",
      "link": "false",
      "alt_text": "Kitchen area with orange counter and wooden cabinets, white refrigerator and stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (31).JPG"
    },
    {
      "id": "ec_24c1ee487dc0cd614399c67c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f45-d1f4-752f-aa59-2edf93ee98cf.webp",
      "image_media": {
        "alt_text": "Kitchenette with orange countertop and white cabinets open to a living area with grey carpet.",
        "public_id": "01a11f45-d1f4-752f-aa59-2edf93ee98cf",
        "storage_key": "property/6767906449167169/01a11f45-d1f4-752f-aa59-2edf93ee98cf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy kitchenette featuring an orange breakfast bar and white cabinetry, seamlessly integrated with the spacious living area and carpeted flooring.",
      "link": "false",
      "alt_text": "Kitchenette with orange countertop and white cabinets open to a living area with grey carpet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (32).JPG"
    },
    {
      "id": "ec_6ac7f5545f0d6db614db1b9d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f45-d069-7086-b8f5-01e1787f6831.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment unit, showing a living area, kitchen counter, and an open closet.",
        "public_id": "01a11f45-d069-7086-b8f5-01e1787f6831",
        "storage_key": "property/6767906449167169/01a11f45-d069-7086-b8f5-01e1787f6831.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and carpeted living area with an open concept kitchen, featuring a breakfast bar and ample cabinet space. Includes a glimpse into a closet and bathroom.",
      "link": "false",
      "alt_text": "Interior view of an apartment unit, showing a living area, kitchen counter, and an open closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (38).JPG"
    },
    {
      "id": "ec_1fe03505e884b08fcfdfbbd4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f45-b423-73ba-89d5-86235c06f80c.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with orange countertop and wooden cabinets",
        "public_id": "01a11f45-b423-73ba-89d5-86235c06f80c",
        "storage_key": "property/6767906449167169/01a11f45-b423-73ba-89d5-86235c06f80c.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Stylish kitchen and dining area featuring a vibrant orange countertop, modern wooden cabinetry, and comfortable seating, perfect for everyday living.",
      "link": "false",
      "alt_text": "Kitchen and dining area with orange countertop and wooden cabinets",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (22).jpg"
    },
    {
      "id": "ec_6feffcfaec262bb8aa3c429d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d021b-b245-764d-8fc3-a7fb169cf51d.webp",
      "image_media": {
        "alt_text": "Kitchenette with white refrigerator, stove, and orange countertops.",
        "public_id": "019d021b-b245-764d-8fc3-a7fb169cf51d",
        "storage_key": "property/6767906449167169/019d021b-b245-764d-8fc3-a7fb169cf51d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Compact kitchenette featuring a white refrigerator, stove, and vibrant orange countertops, perfect for any apartment unit.",
      "link": "false",
      "alt_text": "Kitchenette with white refrigerator, stove, and orange countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (25).JPG"
    },
    {
      "id": "ec_fe147db03b3024174b2969d5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f45-ea99-7756-ae4d-376fbfe38f16.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, coffee table, and large sliding glass doors.",
        "public_id": "01a11f45-ea99-7756-ae4d-376fbfe38f16",
        "storage_key": "property/6767906449167169/01a11f45-ea99-7756-ae4d-376fbfe38f16.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa, a stylish coffee table, and abundant natural light from large sliding glass doors.",
      "link": "false",
      "alt_text": "Modern living room with a sectional sofa, coffee table, and large sliding glass doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (23).jpg"
    },
    {
      "id": "ec_ac23d1a64677dd8167bff904",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f46-0aaa-70a5-a509-f3de1f3623f2.webp",
      "image_media": {
        "alt_text": "Empty apartment living area with a closet and a partial view of the kitchen.",
        "public_id": "01a11f46-0aaa-70a5-a509-f3de1f3623f2",
        "storage_key": "property/6767906449167169/01a11f46-0aaa-70a5-a509-f3de1f3623f2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This spacious apartment features a large closet and an open-concept living area that flows into the kitchen space.",
      "link": "false",
      "alt_text": "Empty apartment living area with a closet and a partial view of the kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (37).JPG"
    },
    {
      "id": "ec_11f5560815e5df69ea48b5a4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f46-1457-761a-bcb5-8884bd60f4f1.webp",
      "image_media": {
        "alt_text": "Interior view of an empty apartment living room with carpet, a sliding glass door, and a window.",
        "public_id": "01a11f46-1457-761a-bcb5-8884bd60f4f1",
        "storage_key": "property/6767906449167169/01a11f46-1457-761a-bcb5-8884bd60f4f1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious apartment living room featuring plush carpeting, a large sliding glass door providing outdoor views, and ample natural light. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Interior view of an empty apartment living room with carpet, a sliding glass door, and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (33).JPG"
    },
    {
      "id": "ec_19bf17a5d5e8ae0eb6b09ea8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f46-1593-741c-94b0-b5c3b280c0f5.webp",
      "image_media": {
        "alt_text": "View of a bedroom with a closet and an adjoining bathroom.",
        "public_id": "01a11f46-1593-741c-94b0-b5c3b280c0f5",
        "storage_key": "property/6767906449167169/01a11f46-1593-741c-94b0-b5c3b280c0f5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this cozy bedroom, featuring a spacious closet and convenient access to a well-appointed bathroom. The neutral tones and carpeted flooring create a comfortable and inviting atmosphere.",
      "link": "false",
      "alt_text": "View of a bedroom with a closet and an adjoining bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (30).JPG"
    },
    {
      "id": "ec_2820bc7c07a0f1ea877249d7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f46-02c5-766c-b533-51315bc2a540.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a window overlooking trees.",
        "public_id": "01a11f46-02c5-766c-b533-51315bc2a540",
        "storage_key": "property/6767906449167169/01a11f46-02c5-766c-b533-51315bc2a540.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a comfortable queen-size bed, two matching nightstands with lamps, and a large window that provides natural light and a view of the surrounding greenery.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and a window overlooking trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (21).jpg"
    },
    {
      "id": "ec_dbe160af40811f5e0f2dafeb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d021b-c80a-74e9-a3ad-62f051d54608.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, sink, mirror, and bathtub with shower.",
        "public_id": "019d021b-c80a-74e9-a3ad-62f051d54608",
        "storage_key": "property/6767906449167169/019d021b-c80a-74e9-a3ad-62f051d54608.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with a bright green countertop, a sink, a mirrored medicine cabinet, and a bathtub with a tiled shower surround.",
      "link": "false",
      "alt_text": "Bathroom with a vanity, sink, mirror, and bathtub with shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (28).JPG"
    },
    {
      "id": "ec_1354c9a03ad2152c8e149203",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f46-2dc5-773b-a159-608199fcd27b.webp",
      "image_media": {
        "alt_text": "Empty bedroom with gray carpet and a window with blinds",
        "public_id": "01a11f46-2dc5-773b-a159-608199fcd27b",
        "storage_key": "property/6767906449167169/01a11f46-2dc5-773b-a159-608199fcd27b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A view of an empty bedroom featuring plush gray carpeting and a window with blinds, offering a glimpse of the surrounding greenery.",
      "link": "false",
      "alt_text": "Empty bedroom with gray carpet and a window with blinds",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (27).JPG"
    },
    {
      "id": "ec_038e1c08e14e387a6ab5cc23",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d021b-d0c1-75ba-9c81-12f911aabfe8.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washers and dryers",
        "public_id": "019d021b-d0c1-75ba-9c81-12f911aabfe8",
        "storage_key": "property/6767906449167169/019d021b-d0c1-75ba-9c81-12f911aabfe8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "On-site laundry facilities make chores a breeze. Fully equipped with multiple washers and dryers for your convenience.",
      "link": "false",
      "alt_text": "Laundry room with multiple washers and dryers",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (26).JPG"
    },
    {
      "id": "ec_5a257842da1b0896042b5931",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f46-51c3-7365-8729-1711ae65bb0c.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, toilet, sink, and vanity with mirror.",
        "public_id": "01a11f46-51c3-7365-8729-1711ae65bb0c",
        "storage_key": "property/6767906449167169/01a11f46-51c3-7365-8729-1711ae65bb0c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a bathtub with shower, a toilet, and a vanity with a sink and ample counter space. The vanity includes a mirrored medicine cabinet.",
      "link": "false",
      "alt_text": "Bathroom with bathtub, toilet, sink, and vanity with mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (24).JPG"
    },
    {
      "id": "ec_7477acf6df40c47d69e62904",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f46-6dd6-778b-baf8-67fcc095f8e3.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily building with a parking lot and a pickup truck.",
        "public_id": "01a11f46-6dd6-778b-baf8-67fcc095f8e3",
        "storage_key": "property/6767906449167169/01a11f46-6dd6-778b-baf8-67fcc095f8e3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of a three-story multifamily building featuring balconies, large windows, and a parking lot in front.",
      "link": "false",
      "alt_text": "Exterior of a multifamily building with a parking lot and a pickup truck.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (34).JPG"
    },
    {
      "id": "ec_2c1215ed7763c8a6fe395567",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f46-67f8-7067-8250-d23df11dc737.webp",
      "image_media": {
        "alt_text": "Exterior view of a three-story apartment building with balconies and parking lot.",
        "public_id": "01a11f46-67f8-7067-8250-d23df11dc737",
        "storage_key": "property/6767906449167169/01a11f46-67f8-7067-8250-d23df11dc737.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View the exterior of this apartment building, featuring multiple levels with balconies and a well-maintained parking area. Discover your new home today.",
      "link": "false",
      "alt_text": "Exterior view of a three-story apartment building with balconies and parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (40).JPG"
    },
    {
      "id": "ec_ef57526298d3d2764c8e24f9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f46-608a-7290-ba09-b9d51bd34601.webp",
      "image_media": {
        "alt_text": "Exterior of a multi-story apartment building with balconies and a parking lot.",
        "public_id": "01a11f46-608a-7290-ba09-b9d51bd34601",
        "storage_key": "property/6767906449167169/01a11f46-608a-7290-ba09-b9d51bd34601.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the apartment building, showcasing its multi-story structure with balconies and a well-maintained parking lot. Offers a glimpse of the property's curb appeal.",
      "link": "false",
      "alt_text": "Exterior of a multi-story apartment building with balconies and a parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (35).JPG"
    },
    {
      "id": "ec_3a51ee773c81b5f8bed683b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a11f46-6414-7318-8491-d14f40da2c78.webp",
      "image_media": {
        "alt_text": "Exterior of a multi-story apartment building with balconies and a parking lot.",
        "public_id": "01a11f46-6414-7318-8491-d14f40da2c78",
        "storage_key": "property/6767906449167169/01a11f46-6414-7318-8491-d14f40da2c78.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "This apartment building features multiple levels with private balconies and ample parking. The exterior showcases a neutral color palette and well-maintained landscaping.",
      "link": "false",
      "alt_text": "Exterior of a multi-story apartment building with balconies and a parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Arbor-Point_Favorites (29).JPG"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_25f2ab7e-f40f-410f-a6ea-4a7ef0467ff1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Bear Tooth Theatrepub",
      "poi_type": "Entertainment",
      "poi_address": "1230 W 27th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_long_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b2-ee14-752f-b2d4-9f0a13096c2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b2-ee14-752f-b2d4-9f0a13096c2f",
        "storage_key": "property/6767906449167169/01a140b2-ee14-752f-b2d4-9f0a13096c2f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beartoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10145190151877577635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-tooth-theatrepub",
      "poi_latitude": "61.1959573",
      "poi_longitude": "-149.9070452",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-276-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-63f8-725a-b294-0a0cb568a4cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-63f8-725a-b294-0a0cb568a4cc",
        "storage_key": "property/6767906449167169/019d0220-63f8-725a-b294-0a0cb568a4cc.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_p-3NuXyFYRo0t0DbH0yow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_98be86d8-1568-4bbc-a588-9077910e8251",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Moose's Tooth Pub & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "3300 Old Seward Hwy, Anchorage, AK 99503, USA",
      "poi_short_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_long_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b1-63f0-77ee-963b-f7139ae6cc8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b1-63f0-77ee-963b-f7139ae6cc8b",
        "storage_key": "property/6767906449167169/01a140b1-63f0-77ee-963b-f7139ae6cc8b.webp",
        "width": 1280,
        "height": 889
      },
      "poi_business_url": "https://www.moosestoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15494600602096929900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mooses-tooth-pub--pizzeria",
      "poi_latitude": "61.1905009",
      "poi_longitude": "-149.86910369999998",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-258-2537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6400-7315-9dbe-6cb35e788e70",
        "storage_key": "property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3wBgzrmXyFYRbIyKWCfhB9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_09e3eef2-337a-42c7-be65-dae27958e2bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Spenard Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1049 W Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Varied fare (such as Thai curry, burgers & pizza), plus beer & cocktails in a bright, casual eatery.",
      "poi_long_description": "Varied fare (such as Thai curry, burgers & pizza), plus beer & cocktails in a bright, casual eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-11f2-7272-96de-d1bc93a2b6f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-11f2-7272-96de-d1bc93a2b6f9",
        "storage_key": "property/6767906449167169/019d0220-11f2-7272-96de-d1bc93a2b6f9.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "http://www.spenardroadhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10079478686688268729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spenard-roadhouse",
      "poi_latitude": "61.19552819999999",
      "poi_longitude": "-149.9032167",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-770-7623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6400-7315-9dbe-6cb35e788e70",
        "storage_key": "property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRAGpNuXyFYRudEsUXaA4Ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0cfcaccf-16cf-4ddf-8a2b-dd8dfa7a2f1b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Tommy's Burger Stop-Spenard",
      "poi_type": "Restaurants",
      "poi_address": "1106 W 29th Pl, Anchorage, AK 99503, USA",
      "poi_short_description": "Gourmet hamburgers, onion rings & seasoned fries in a brightly-colored house with a casual vibe.",
      "poi_long_description": "Gourmet hamburgers, onion rings & seasoned fries in a brightly-colored house with a casual vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b2-eac9-7015-935a-dd72de9434c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b2-eac9-7015-935a-dd72de9434c5",
        "storage_key": "property/6767906449167169/01a140b2-eac9-7015-935a-dd72de9434c5.webp",
        "width": 800,
        "height": 460
      },
      "poi_business_url": "http://tommysburgerstop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12050658426381529807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tommys-burger-stop-spenard",
      "poi_latitude": "61.1935721",
      "poi_longitude": "-149.90451969999998",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-561-5696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6400-7315-9dbe-6cb35e788e70",
        "storage_key": "property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb6YSfNuXyFYRz_IJ3v2JPKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_ab83d60d-3db1-4f36-b380-ab4345f21e45",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Spenard Joe's",
      "poi_type": "Restaurants",
      "poi_address": "3831 Spenard Rd, Anchorage, AK 99517, USA",
      "poi_short_description": "Charming neighborhood cafe serving creative coffee drinks and made-to-order sandwiches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b2-ee2b-719e-ad72-de28325c6626.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b2-ee2b-719e-ad72-de28325c6626",
        "storage_key": "property/6767906449167169/01a140b2-ee2b-719e-ad72-de28325c6626.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://spenardjoescoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17055551677061521500&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spenard-joes",
      "poi_latitude": "61.1857848",
      "poi_longitude": "-149.918103",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6411-7678-8927-1c2a6cca3bc3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6411-7678-8927-1c2a6cca3bc3",
        "storage_key": "property/6767906449167169/019d0220-6411-7678-8927-1c2a6cca3bc3.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJtR66pd-XyFYRXOCR1-J9sew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_01ea3013-d882-43d2-a06c-3b73d80cac47",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Phở Lena",
      "poi_type": "Restaurants",
      "poi_address": "3311 Spenard Rd, Anchorage, AK 99503, USA",
      "poi_short_description": "Casual Southeast Asian restaurant serving a wide variety of dishes including signature pho.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b2-ee2e-755f-8568-7e9621fbf639.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b2-ee2e-755f-8568-7e9621fbf639",
        "storage_key": "property/6767906449167169/01a140b2-ee2e-755f-8568-7e9621fbf639.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://pholena.com/spenard_menu",
      "poi_directions_map_url": "https://maps.google.com/?cid=2305177164884255596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ph-lena",
      "poi_latitude": "61.189924600000005",
      "poi_longitude": "-149.9074225",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-277-9777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6400-7315-9dbe-6cb35e788e70",
        "storage_key": "property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTcDRftyXyFYRbKNECWui_R8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_64b5a864-d514-47bb-9f6e-f7fe91ef48f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Yak & Yeti Himalayan Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3301 Spenard Rd, Anchorage, AK 99503, USA",
      "poi_short_description": "Relaxed eatery serving traditional Indian, Tibetan & Nepalese bites such as goat curry & tingmo.",
      "poi_long_description": "Relaxed eatery serving traditional Indian, Tibetan & Nepalese bites such as goat curry & tingmo.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b2-edb9-762b-bc97-ec065b07500a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b2-edb9-762b-bc97-ec065b07500a",
        "storage_key": "property/6767906449167169/01a140b2-edb9-762b-bc97-ec065b07500a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.yakandyetialaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1448222236593515273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yak--yeti-himalayan-restaurant",
      "poi_latitude": "61.1906632",
      "poi_longitude": "-149.9068825",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-743-8078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6400-7315-9dbe-6cb35e788e70",
        "storage_key": "property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUD4HN2XyFYRCWv6f3MeGRQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f77f7d25-752a-4010-85da-356cc0d7a850",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Jackie's Place Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2632 Spenard Rd, Anchorage, AK 99503, USA",
      "poi_short_description": "Down-to-earth breakfast & lunch spot offering build-your-own omelets with a variety of ingredients.",
      "poi_long_description": "Down-to-earth breakfast & lunch spot offering build-your-own omelets with a variety of ingredients.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b2-f327-706d-aedd-58714411a336.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b2-f327-706d-aedd-58714411a336",
        "storage_key": "property/6767906449167169/01a140b2-f327-706d-aedd-58714411a336.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jackiesplacealaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9563495962138211860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jackies-place-restaurant",
      "poi_latitude": "61.196529299999995",
      "poi_longitude": "-149.906845",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-274-3211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6400-7315-9dbe-6cb35e788e70",
        "storage_key": "property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6eQbztuXyFYRFHYhcuhcuIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e1f56823-bfe8-4c8a-aef3-d3f3df54d297",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Jens' Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "701 W 36th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "Inventive Continental cooking served in an art-filled dining room & wine bar inside a strip mall.",
      "poi_long_description": "Inventive Continental cooking served in an art-filled dining room & wine bar inside a strip mall.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b2-f344-775a-a344-32c622ae1fce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b2-f344-775a-a344-32c622ae1fce",
        "storage_key": "property/6767906449167169/01a140b2-f344-775a-a344-32c622ae1fce.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.jensrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2371103546387498217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jens-restaurant",
      "poi_latitude": "61.1890855",
      "poi_longitude": "-149.8965651",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-561-5367",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6400-7315-9dbe-6cb35e788e70",
        "storage_key": "property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ90egSsKXyFYR6YQY4Bza5yA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_2fb0428e-3f97-4ec8-8da5-4c7594e76d76",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Snow City Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1034 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_long_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b2-eaa7-74eb-9f3c-dcdc884857fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b2-eaa7-74eb-9f3c-dcdc884857fd",
        "storage_key": "property/6767906449167169/01a140b2-eaa7-74eb-9f3c-dcdc884857fd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snowcitycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2005746570144512581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snow-city-cafe",
      "poi_latitude": "61.2184015",
      "poi_longitude": "-149.9033331",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-272-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6411-7678-8927-1c2a6cca3bc3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6411-7678-8927-1c2a6cca3bc3",
        "storage_key": "property/6767906449167169/019d0220-6411-7678-8927-1c2a6cca3bc3.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJQcnnU4G9yFYRRfrr7uDX1Rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_5be03619-8983-4f15-9ed0-10bf5e5cbdea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Salsa Oaxaqueña | Mexican Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "3505 Spenard Rd B, Anchorage, AK 99503, USA",
      "poi_short_description": "Authentic Mexican eatery specializing in traditional mole and handmade tortillas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b2-f58f-7094-8d5e-e9fecb8f2d65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b2-f58f-7094-8d5e-e9fecb8f2d65",
        "storage_key": "property/6767906449167169/01a140b2-f58f-7094-8d5e-e9fecb8f2d65.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.salsaoaxaqueńa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6615111832159973163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salsa-oaxaquea--mexican-cuisine",
      "poi_latitude": "61.1882896",
      "poi_longitude": "-149.9080625",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-865-5375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6400-7315-9dbe-6cb35e788e70",
        "storage_key": "property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjfc0eUiXyFYRK-9guSmZzVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_f351050c-082c-44a7-b2ba-e12888108db7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Gwennie's Old Alaska Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4333 Spenard Rd, Anchorage, AK 99517, USA",
      "poi_short_description": "Home cooking & all-day breakfasts in an eatery filled with knickknacks, native art & old photos.",
      "poi_long_description": "Home cooking & all-day breakfasts in an eatery filled with knickknacks, native art & old photos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-0011-7608-ad3b-74fd7fd1c491.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-0011-7608-ad3b-74fd7fd1c491",
        "storage_key": "property/6767906449167169/01a140b3-0011-7608-ad3b-74fd7fd1c491.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gwenniesoldalaskarestaurant.top/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15781866237967564527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwennies-old-alaska-restaurant",
      "poi_latitude": "61.1818463",
      "poi_longitude": "-149.93271719999998",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-243-2090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6400-7315-9dbe-6cb35e788e70",
        "storage_key": "property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpXZvL-OXyFYR737JPrpzBNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_fb42701d-60de-4fc6-a3e9-23f814eb6d10",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "White Spot Cafe",
      "poi_type": "Restaurants",
      "poi_address": "109 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Classic diner for American grub plus Alaskan specialties like reindeer sausage & fried halibut.",
      "poi_long_description": "Classic diner for American grub plus Alaskan specialties like reindeer sausage & fried halibut.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b2-f51e-74fa-9d2e-d6351f441c5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b2-f51e-74fa-9d2e-d6351f441c5d",
        "storage_key": "property/6767906449167169/01a140b2-f51e-74fa-9d2e-d6351f441c5d.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.clover.com/online-ordering/white-spot-cafe-anchorage-2",
      "poi_directions_map_url": "https://maps.google.com/?cid=7584368616237936317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "white-spot-cafe",
      "poi_latitude": "61.2187413",
      "poi_longitude": "-149.8838113",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-279-3954",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6400-7315-9dbe-6cb35e788e70",
        "storage_key": "property/6767906449167169/019d0220-6400-7315-9dbe-6cb35e788e70.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD_Px9SiWyFYRva57oBIXQWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b7a31e07-c21d-46a1-b807-61c1ecf1ae0e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Carrs",
      "poi_type": "Shopping & Retail",
      "poi_address": "1650 W Northern Lights Blvd, Anchorage, AK 99517, USA",
      "poi_short_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_long_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-1e1c-7708-aa15-39081b607dd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-1e1c-7708-aa15-39081b607dd1",
        "storage_key": "property/6767906449167169/019d0220-1e1c-7708-aa15-39081b607dd1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.carrsqc.com/ak/anchorage/1650-w-northern-lights-blvd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=9604229126923677976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs",
      "poi_latitude": "61.194192300000005",
      "poi_longitude": "-149.9152977",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-339-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6808-70ca-bcd2-576ca9b0109c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6808-70ca-bcd2-576ca9b0109c",
        "storage_key": "property/6767906449167169/019d0220-6808-70ca-bcd2-576ca9b0109c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ771g3N6XyFYRGPG-a4ETSYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c04c9e9c-de20-4b54-9805-5fab0b730de7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Midtown Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "600 E Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Local shopping mall featuring national retailers and community events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b2-f86d-776d-8f89-3197cae60ab4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b2-f86d-776d-8f89-3197cae60ab4",
        "storage_key": "property/6767906449167169/01a140b2-f86d-776d-8f89-3197cae60ab4.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.midtownmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4997748520237238523&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown-mall",
      "poi_latitude": "61.194266199999994",
      "poi_longitude": "-149.8717154",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-416-8989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6814-767a-b33d-b5f8008a7972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6814-767a-b33d-b5f8008a7972",
        "storage_key": "property/6767906449167169/019d0220-6814-767a-b33d-b5f8008a7972.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJd9GYJciXyFYR-4h5ycyRW0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1ec94a5c-2ed9-4f83-99e6-e32f3c3ff023",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3101 A St, Anchorage, AK 99503, USA",
      "poi_short_description": "Comprehensive department store featuring a wide selection of groceries and general merchandise.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-245e-71dc-a2c2-64a8bf1061b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-245e-71dc-a2c2-64a8bf1061b1",
        "storage_key": "property/6767906449167169/019d0220-245e-71dc-a2c2-64a8bf1061b1.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2070-anchorage-ak/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=4726814419269219339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "61.19226449999999",
      "poi_longitude": "-149.8802642",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-563-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6814-767a-b33d-b5f8008a7972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6814-767a-b33d-b5f8008a7972",
        "storage_key": "property/6767906449167169/019d0220-6814-767a-b33d-b5f8008a7972.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOe6XNsaXyFYRC3S8q6sEmUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_8059303a-b543-41b2-9d28-500db6fc94c5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "1000 E Northern Lights Blvd, Anchorage, AK 99508, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-aa00-7078-8cfc-5a80e75c2106.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-aa00-7078-8cfc-5a80e75c2106",
        "storage_key": "property/6767906449167169/019d0220-aa00-7078-8cfc-5a80e75c2106.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/ak/anchorage/anchorage/701/00011?cid=loc_70100011_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8636677180229535916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "61.194478800000006",
      "poi_longitude": "-149.863708",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-264-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6808-70ca-bcd2-576ca9b0109c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6808-70ca-bcd2-576ca9b0109c",
        "storage_key": "property/6767906449167169/019d0220-6808-70ca-bcd2-576ca9b0109c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX9dGZ7aXyFYRrMhN5yKk23c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_85ef48d8-1285-47cb-ab47-a6b56489628b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "REI",
      "poi_type": "Shopping & Retail",
      "poi_address": "500 E Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Retail chain carrying gear, apparel & footwear for a wide range of outdoor & fitness activities.",
      "poi_long_description": "Retail chain carrying gear, apparel & footwear for a wide range of outdoor & fitness activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b2-fb3b-775d-9759-93a8e5f3551f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b2-fb3b-775d-9759-93a8e5f3551f",
        "storage_key": "property/6767906449167169/01a140b2-fb3b-775d-9759-93a8e5f3551f.webp",
        "width": 1280,
        "height": 827
      },
      "poi_business_url": "https://www.rei.com/stores/anchorage?y_source=1_MTQ1MzM3Mi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5020379491111971094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rei",
      "poi_latitude": "61.19428980000001",
      "poi_longitude": "-149.875307",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-272-4565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6814-767a-b33d-b5f8008a7972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6814-767a-b33d-b5f8008a7972",
        "storage_key": "property/6767906449167169/019d0220-6814-767a-b33d-b5f8008a7972.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH666iNuXyFYRFqliTYz4q0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_3a0ed714-9a49-4594-bca8-385047679b6d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Nordstrom Rack",
      "poi_type": "Shopping & Retail",
      "poi_address": "680 E Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Off-price department store featuring a variety of discounted designer clothing and footwear.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b2-fb17-72db-b1bc-945dffb0a082.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b2-fb17-72db-b1bc-945dffb0a082",
        "storage_key": "property/6767906449167169/01a140b2-fb17-72db-b1bc-945dffb0a082.webp",
        "width": 1280,
        "height": 1101
      },
      "poi_business_url": "https://stores.nordstromrack.com/us/ak/anchorage/680-e-northern-lights-blvd?utm_source=google&utm_medium=organic&utm_campaign=rack&utm_content=11&utm_channel=low_nd_seo_local&sp_source=google&sp_campaign=rack",
      "poi_directions_map_url": "https://maps.google.com/?cid=12402218146542438781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nordstrom-rack",
      "poi_latitude": "61.194891",
      "poi_longitude": "-149.870694",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-334-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6814-767a-b33d-b5f8008a7972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6814-767a-b33d-b5f8008a7972",
        "storage_key": "property/6767906449167169/019d0220-6814-767a-b33d-b5f8008a7972.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ_9cLMiXyFYRfcmQy7GHHaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_dcd59992-b9bf-4cd0-aaa1-f887c7c36187",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "3727 Spenard Rd, Anchorage, AK 99517, USA",
      "poi_short_description": "Chain convenience store offering snacks and beverages, plus gas pumps.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-065d-7758-97bd-94799896a324.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-065d-7758-97bd-94799896a324",
        "storage_key": "property/6767906449167169/01a140b3-065d-7758-97bd-94799896a324.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/anchorage/3727-spenard-rd/2746630?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=7574310151999899200&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "61.1861928",
      "poi_longitude": "-149.9140401",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-563-9093",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-3ad5-739f-a0e2-46bc46e08192.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140b3-3ad5-739f-a0e2-46bc46e08192",
        "storage_key": "property/6767906449167169/01a140b3-3ad5-739f-a0e2-46bc46e08192.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ1c_iq-eXyFYRQMaW7PNaHWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_3ebdc09b-1a68-4623-b2d5-63fdec47f720",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1470 W Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-0026-7056-857c-d9f1553bceea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-0026-7056-857c-d9f1553bceea",
        "storage_key": "property/6767906449167169/01a140b3-0026-7056-857c-d9f1553bceea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1470+w+northern+lights+blvd-anchorage-ak-99503/id=15092",
      "poi_directions_map_url": "https://maps.google.com/?cid=5983687261204770314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "61.1946778",
      "poi_longitude": "-149.9120897",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-770-2503",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6808-70ca-bcd2-58e5527bebd9",
        "storage_key": "property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqbDasN6XyFYRCu4jc9xTClM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_bfe27a76-45a2-4fc7-896f-6194d904341b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Guitar Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "2880 Seward Hwy, Anchorage, AK 99503, USA",
      "poi_short_description": "Comprehensive music store offering a wide selection of instruments, recording equipment, and studio gear.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-008c-73e8-b0fc-580325a4519f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-008c-73e8-b0fc-580325a4519f",
        "storage_key": "property/6767906449167169/01a140b3-008c-73e8-b0fc-580325a4519f.webp",
        "width": 1280,
        "height": 801
      },
      "poi_business_url": "https://stores.guitarcenter.com/ak/anchorage/261?source=4GOSBM6BAM",
      "poi_directions_map_url": "https://maps.google.com/?cid=16243253337603337571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "guitar-center",
      "poi_latitude": "61.194775199999995",
      "poi_longitude": "-149.8709313",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-222-5155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6814-767a-b33d-b5f8008a7972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6814-767a-b33d-b5f8008a7972",
        "storage_key": "property/6767906449167169/019d0220-6814-767a-b33d-b5f8008a7972.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJiRe1axeXyFYRY22GoNmga-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_b9f7a4fb-6fde-4bd0-9b1e-dc3bfcbcf3ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Stallone's Menswear",
      "poi_type": "Shopping & Retail",
      "poi_address": "600 E Northern Lights Blvd #138, Anchorage, AK 99503, USA",
      "poi_short_description": "Men's clothing store offering a large selection of suits and professional tailoring services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-058f-752e-84e8-1752bcff158b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-058f-752e-84e8-1752bcff158b",
        "storage_key": "property/6767906449167169/01a140b3-058f-752e-84e8-1752bcff158b.webp",
        "width": 1280,
        "height": 514
      },
      "poi_business_url": "http://www.stallonesmenswear.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6896758902877003488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stallones-menswear",
      "poi_latitude": "61.194154299999994",
      "poi_longitude": "-149.8725389",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-274-7848",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6814-767a-b33d-b5f8008a7972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6814-767a-b33d-b5f8008a7972",
        "storage_key": "property/6767906449167169/019d0220-6814-767a-b33d-b5f8008a7972.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJd9GYJciXyFYR4B5_e641tl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_bea89b74-2f14-486f-ad2d-09530e2ad9a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Romig Middle School",
      "poi_type": "Education",
      "poi_address": "2500 Minnesota Dr, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-0537-7264-9c11-0399e5e44169.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-0537-7264-9c11-0399e5e44169",
        "storage_key": "property/6767906449167169/01a140b3-0537-7264-9c11-0399e5e44169.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.asdk12.org/romig",
      "poi_directions_map_url": "https://maps.google.com/?cid=8817967304801863302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "romig-middle-school",
      "poi_latitude": "61.1983852",
      "poi_longitude": "-149.91456820000002",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-742-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-686b-74ad-a469-dbcca425a008",
        "storage_key": "property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVzXvI9mXyFYRhka5S4u2X3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5eef958c-d758-40f6-9e06-b26f995e04a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Willow Crest Elementary School",
      "poi_type": "Education",
      "poi_address": "1004 W Tudor Rd, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/willowcrest",
      "poi_directions_map_url": "https://maps.google.com/?cid=2810682685606197606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willow-crest-elementary-school",
      "poi_latitude": "61.18010379999999",
      "poi_longitude": "-149.9035735",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-742-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-686b-74ad-a469-dbcca425a008",
        "storage_key": "property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJda6VA-yXyFYRZvnlywKNASc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_aab6cd05-c679-44c7-bcfa-73cb45801655",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Holy Rosary Academy",
      "poi_type": "Education",
      "poi_address": "1846 E 64th Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-2e4b-744c-9473-398a3a953837.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-2e4b-744c-9473-398a3a953837",
        "storage_key": "property/6767906449167169/019d0220-2e4b-744c-9473-398a3a953837.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.hraak.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3253552454997321548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-rosary-academy",
      "poi_latitude": "61.1618452",
      "poi_longitude": "-149.8482473",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-276-5822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-686b-74ad-a469-dbcca425a008",
        "storage_key": "property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGY3NDNqXyFYRTCc3QrjwJi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_9054f0c6-403b-4bfa-a7fa-52efd0dd2de6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "West Anchorage High School",
      "poi_type": "Education",
      "poi_address": "1700 Hillcrest Dr, Anchorage, AK 99517, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-0715-7518-b522-442aad2c7452.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-0715-7518-b522-442aad2c7452",
        "storage_key": "property/6767906449167169/01a140b3-0715-7518-b522-442aad2c7452.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://west.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15684090881757896505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-anchorage-high-school",
      "poi_latitude": "61.2007784",
      "poi_longitude": "-149.9166486",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-742-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-686b-74ad-a469-dbcca425a008",
        "storage_key": "property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeXfsf2K9yFYROV8fII8Vqdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_50f5a58b-63b3-4bd4-ae7f-686aa1bdd1be",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Northern Lights Preschool & Child Care",
      "poi_type": "Education",
      "poi_address": "703 W Northern Lights Blvd Ste 200, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-07db-705f-81be-5c9b8b02207f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-07db-705f-81be-5c9b8b02207f",
        "storage_key": "property/6767906449167169/01a140b3-07db-705f-81be-5c9b8b02207f.webp",
        "width": 1000,
        "height": 562
      },
      "poi_business_url": "http://www.nlpkak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6040540510000710581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northern-lights-preschool--child-care",
      "poi_latitude": "61.195476",
      "poi_longitude": "-149.8967867",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-274-2040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-686b-74ad-a469-dbcca425a008",
        "storage_key": "property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJfvXzdqXyFYRtQPz9ZZP1FM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_0c642702-d40c-42cc-b43d-032ef2afc0b0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "University of Alaska Anchorage",
      "poi_type": "Education",
      "poi_address": "3211 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-2e73-732d-974f-6133af413edd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-2e73-732d-974f-6133af413edd",
        "storage_key": "property/6767906449167169/019d0220-2e73-732d-974f-6133af413edd.webp",
        "width": 672,
        "height": 400
      },
      "poi_business_url": "https://www.uaa.alaska.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2963319407001083725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-alaska-anchorage",
      "poi_latitude": "61.1910421",
      "poi_longitude": "-149.81955979999998",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-786-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-686b-74ad-a469-dbcca425a008",
        "storage_key": "property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8bmy6gCXyFYRTR9S4kzTHyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_19ea01d5-9dca-49b5-87ea-0180ac7f4f9f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Alaska Pacific University",
      "poi_type": "Education",
      "poi_address": "4101 University Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-3125-7106-bc3f-dbbb61863556.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-3125-7106-bc3f-dbbb61863556",
        "storage_key": "property/6767906449167169/019d0220-3125-7106-bc3f-dbbb61863556.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.alaskapacific.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11603594146335186940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-pacific-university",
      "poi_latitude": "61.1892616",
      "poi_longitude": "-149.8065058",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-252-7528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-686b-74ad-a469-dbcca425a008",
        "storage_key": "property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsU8plvyWyFYR_F8cymU_CKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_cc04bf2a-c8ef-4d86-ac0b-a35844c9b8fb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Anchorage Montessori School",
      "poi_type": "Education",
      "poi_address": "5001 Northwood Dr, Anchorage, AK 99517, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.anchoragemontessorischool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15064255442461637784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-montessori-school",
      "poi_latitude": "61.17547279999999",
      "poi_longitude": "-149.92657219999998",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-276-2240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-686b-74ad-a469-dbcca425a008",
        "storage_key": "property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB8QsaPqXyFYRmLyr1YL8DtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_a11ed57d-1a7d-45d7-8bdf-aba6db770ffd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Anchorage Waldorf School",
      "poi_type": "Education",
      "poi_address": "3250 Baxter Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-0b7f-743b-b81b-67d64644147e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-0b7f-743b-b81b-67d64644147e",
        "storage_key": "property/6767906449167169/01a140b3-0b7f-743b-b81b-67d64644147e.webp",
        "width": 940,
        "height": 788
      },
      "poi_business_url": "http://waldorfak.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18361981143723653720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-waldorf-school",
      "poi_latitude": "61.191018",
      "poi_longitude": "-149.764458",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-333-9062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-686b-74ad-a469-dbcca425a008",
        "storage_key": "property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsQvwMt2WyFYRWLoRdJDc0v4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_32759d46-eb17-452a-b4a2-8ab95a3eaa6f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Anchorage Museum",
      "poi_type": "Entertainment",
      "poi_address": "625 C St, Anchorage, AK 99501, USA",
      "poi_short_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_long_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b1-6aa2-765a-b330-77fad32510f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b1-6aa2-765a-b330-77fad32510f0",
        "storage_key": "property/6767906449167169/01a140b1-6aa2-765a-b330-77fad32510f0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.anchoragemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6288654669058341295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-museum",
      "poi_latitude": "61.2162281",
      "poi_longitude": "-149.8855791",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-929-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6d65-758d-b4ce-501cc70cebcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6d65-758d-b4ce-501cc70cebcd",
        "storage_key": "property/6767906449167169/019d0220-6d65-758d-b4ce-501cc70cebcd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUPnbCmWyFYRr_lSUBrKRVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_174178e2-9bfc-4db3-ac32-7a1674ada98a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Alaska Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "621 W 6th Ave Suite ACPA, Anchorage, AK 99501, USA",
      "poi_short_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_long_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-3264-751d-956e-2e9275224c82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-3264-751d-956e-2e9275224c82",
        "storage_key": "property/6767906449167169/019d0220-3264-751d-956e-2e9275224c82.webp",
        "width": 1152,
        "height": 648
      },
      "poi_business_url": "https://www.alaskapac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14135362058056830395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-center-for-the-performing-arts",
      "poi_latitude": "61.2170565",
      "poi_longitude": "-149.8943133",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-263-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-3abb-77af-a7d6-4854508d1d65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140b3-3abb-77af-a7d6-4854508d1d65",
        "storage_key": "property/6767906449167169/01a140b3-3abb-77af-a7d6-4854508d1d65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcZ2Uoe9yFYRuw0DQubkKsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_38e981ba-29ef-4f5f-99a2-8782556dfda3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Alaska Native Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8800 Heritage Center Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_long_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-3539-773a-9849-31e7dc482454.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-3539-773a-9849-31e7dc482454",
        "storage_key": "property/6767906449167169/019d0220-3539-773a-9849-31e7dc482454.webp",
        "width": 992,
        "height": 744
      },
      "poi_business_url": "http://www.alaskanative.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2030269464598956769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-heritage-center",
      "poi_latitude": "61.2327673",
      "poi_longitude": "-149.7172142",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-330-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6d65-758d-b4ce-501cc70cebcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6d65-758d-b4ce-501cc70cebcd",
        "storage_key": "property/6767906449167169/019d0220-6d65-758d-b4ce-501cc70cebcd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0B1BT2UyFYR4Uq-O1L3LBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_d22622bf-5153-41e0-873d-2d754f04ae37",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Alaska Aviation Museum",
      "poi_type": "Entertainment",
      "poi_address": "4721 Aircraft Dr, Anchorage, AK 99502, USA",
      "poi_short_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_long_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b1-6b01-7139-a25b-425190498434.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b1-6b01-7139-a25b-425190498434",
        "storage_key": "property/6767906449167169/01a140b1-6b01-7139-a25b-425190498434.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskaairmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15162667059188171085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-aviation-museum",
      "poi_latitude": "61.1793565",
      "poi_longitude": "-149.97190659999998",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-248-5325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6d65-758d-b4ce-501cc70cebcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6d65-758d-b4ce-501cc70cebcd",
        "storage_key": "property/6767906449167169/019d0220-6d65-758d-b4ce-501cc70cebcd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJExnfV029yFYRTYFt5lqdbNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_0ee8f106-6316-4b6d-8e81-d1abad0d881b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "ESCAPE! Alaska",
      "poi_type": "Entertainment",
      "poi_address": "2000 W International Airport Rd Ste A8, Anchorage, AK 99502, USA",
      "poi_short_description": "Immersive escape room center featuring high-production, challenging puzzle experiences.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-1089-77e6-84c0-a7ac50b2e4cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-1089-77e6-84c0-a7ac50b2e4cd",
        "storage_key": "property/6767906449167169/01a140b3-1089-77e6-84c0-a7ac50b2e4cd.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "http://www.escapealaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10788976915308176468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "escape-alaska",
      "poi_latitude": "61.1711993",
      "poi_longitude": "-149.9236162",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-268-2528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b1-9a71-71dd-9b3e-b5fa0fa71ef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140b1-9a71-71dd-9b3e-b5fa0fa71ef8",
        "storage_key": "property/6767906449167169/01a140b1-9a71-71dd-9b3e-b5fa0fa71ef8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0QNMPXiXyFYRVGTVjlclupU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_2e22859d-9803-41d1-a7fb-c6560c2ffa69",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Kincaid Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9401 Raspberry Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Hiking, biking & skiing along groomed trails (a third of which are lit) in a rolling, forested area.",
      "poi_long_description": "Hiking, biking & skiing along groomed trails (a third of which are lit) in a rolling, forested area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b1-7e81-73ea-a787-371ec87169f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b1-7e81-73ea-a787-371ec87169f2",
        "storage_key": "property/6767906449167169/01a140b1-7e81-73ea-a787-371ec87169f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/Pages/Kincaid.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15637430419620688250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kincaid-park",
      "poi_latitude": "61.1536409",
      "poi_longitude": "-150.05538",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-343-6397",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6dc2-7529-b048-12bd0d89ed86",
        "storage_key": "property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwxF8gvOiyFYRevFgsR1QA9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1bbf2965-f771-4a57-a9a7-fa86f2ec8fdd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Sullivan Arena",
      "poi_type": "Entertainment",
      "poi_address": "1600 Gambell St, Anchorage, AK 99501, USA",
      "poi_short_description": "Huge multi-use facility that hosts hockey & basketball games, rock concerts & trade shows.",
      "poi_long_description": "Huge multi-use facility that hosts hockey & basketball games, rock concerts & trade shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b1-706f-722b-a102-833008b38551.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b1-706f-722b-a102-833008b38551",
        "storage_key": "property/6767906449167169/01a140b1-706f-722b-a102-833008b38551.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thesullivanarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=523528862628190629&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sullivan-arena",
      "poi_latitude": "61.20550159999999",
      "poi_longitude": "-149.8727135",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-868-4314",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b1-9a71-71dd-9b3e-b5fa0fa71ef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140b1-9a71-71dd-9b3e-b5fa0fa71ef8",
        "storage_key": "property/6767906449167169/01a140b1-9a71-71dd-9b3e-b5fa0fa71ef8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAADyWyFYRpRmeDrryQwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_58a29263-8add-405f-8b13-0285e17c2c93",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Alaska Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4731 O'Malley Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_long_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-0d1e-74fe-96f3-6c169044546a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-0d1e-74fe-96f3-6c169044546a",
        "storage_key": "property/6767906449167169/01a140b3-0d1e-74fe-96f3-6c169044546a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11640787335481525738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-zoo",
      "poi_latitude": "61.1238025",
      "poi_longitude": "-149.7907",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-3acb-73c7-bb9f-04c7bac082f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140b3-3acb-73c7-bb9f-04c7bac082f6",
        "storage_key": "property/6767906449167169/01a140b3-3acb-73c7-bb9f-04c7bac082f6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH2Yh-ASayFYR6gU-9WdijKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_e3c92424-8ec4-4108-b91a-3884bb6628d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Providence Alaska Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3200 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b1-7c3c-758d-aa12-aee76dc53254.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b1-7c3c-758d-aa12-aee76dc53254",
        "storage_key": "property/6767906449167169/01a140b1-7c3c-758d-aa12-aee76dc53254.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.providence.org/locations/ak/alaska-medical-center?ls=location&y_source=1_OTU3NTY4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1990875543032169585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-alaska-medical-center",
      "poi_latitude": "61.1866256",
      "poi_longitude": "-149.82213539999998",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-562-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6d67-7728-8333-3392e5a2e24e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6d67-7728-8333-3392e5a2e24e",
        "storage_key": "property/6767906449167169/019d0220-6d67-7728-8333-3392e5a2e24e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__razgCXyFYRcQRyHsICoRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_c4218827-d5b3-4b69-9c20-04f2d51ec1e1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Alaska Regional Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2801 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-3bcd-748e-89e6-4524d479eebd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-3bcd-748e-89e6-4524d479eebd",
        "storage_key": "property/6767906449167169/019d0220-3bcd-748e-89e6-4524d479eebd.webp",
        "width": 911,
        "height": 512
      },
      "poi_business_url": "https://www.alaskaregional.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1047679142014347636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-regional-hospital",
      "poi_latitude": "61.2107038",
      "poi_longitude": "-149.8288584",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-276-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6d67-7728-8333-3392e5a2e24e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6d67-7728-8333-3392e5a2e24e",
        "storage_key": "property/6767906449167169/019d0220-6d67-7728-8333-3392e5a2e24e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYPSVUSWyFYRdOlZ-qAaig4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_cc289cab-7b91-4cd0-87a2-14e760fff178",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Providence Urgent Care - Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "1200 W Northern Lights Blvd B, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-0d62-7574-9990-741e98e10638.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-0d62-7574-9990-741e98e10638",
        "storage_key": "property/6767906449167169/01a140b3-0d62-7574-9990-741e98e10638.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.providence.org/locations/urgent-care/ak/urgent-care-midtown?Is=location&y_source=1_MzAxNTI2NzMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16999347318438363632&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-urgent-care---midtown",
      "poi_latitude": "61.1952149",
      "poi_longitude": "-149.9066709",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-212-5165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6808-70ca-bcd2-58e5527bebd9",
        "storage_key": "property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL90jWz6XyFYR8AEC2VHQ6es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_43eca072-d38c-4571-a62d-7c6ed7c398f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Fred Meyer Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1000 E Northern Lights Blvd, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-121f-7269-83ff-800947a08574.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-121f-7269-83ff-800947a08574",
        "storage_key": "property/6767906449167169/01a140b3-121f-7269-83ff-800947a08574.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.fredmeyer.com/rx/pharmacy/details/701/00011?cid=loc_70100011P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14046184150923806975&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer-pharmacy",
      "poi_latitude": "61.19415600000001",
      "poi_longitude": "-149.8638114",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-264-9633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6d6b-7352-9b0b-bb8cb2db8ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6d6b-7352-9b0b-bb8cb2db8ffc",
        "storage_key": "property/6767906449167169/019d0220-6d6b-7352-9b0b-bb8cb2db8ffc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX9dGZ7aXyFYR_wiJvRAS7sI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_2826d759-9d74-4903-ad83-593385327436",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "The Alaska Club West Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 W Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Spacious, energetic gym featuring an extensive group fitness schedule and dedicated strength training areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-40a2-7408-8f50-83b528a55586.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-40a2-7408-8f50-83b528a55586",
        "storage_key": "property/6767906449167169/019d0220-40a2-7408-8f50-83b528a55586.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thealaskaclub.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-tacwest-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=5726141780477587677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alaska-club-west-gym",
      "poi_latitude": "61.19484620000001",
      "poi_longitude": "-149.9103755",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-264-2720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-686b-74ad-a469-dbcca425a008",
        "storage_key": "property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0TAVOciXyFYR3bDjZpxXd08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e91ee2a5-dcf5-4ad6-acf6-631a6df272f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "670 E Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Judgment-free gym providing workout equipment plus tanning and massage amenities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-bab8-71eb-8ed5-bc2b53e5aea1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-bab8-71eb-8ed5-bc2b53e5aea1",
        "storage_key": "property/6767906449167169/019d0220-bab8-71eb-8ed5-bc2b53e5aea1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/anchorage-northern-lights-blvd-ak?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11613855461750134227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "61.19478189999999",
      "poi_longitude": "-149.87190429999998",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-444-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6808-70ca-bcd2-58e5527bebd9",
        "storage_key": "property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSjXk7eXyFYR09VYdgK0LKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_58448f6a-63e7-4453-ae1e-4201b3af59fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Just Reign Cycle Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "2610 Spenard Rd, Anchorage, AK 99503, USA",
      "poi_short_description": "Welcoming fitness center offering high-energy indoor cycling classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-11b5-769d-88bc-2a80abcf1fed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-11b5-769d-88bc-2a80abcf1fed",
        "storage_key": "property/6767906449167169/01a140b3-11b5-769d-88bc-2a80abcf1fed.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.justreign.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12575621159470139560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "just-reign-cycle-studio",
      "poi_latitude": "61.197215",
      "poi_longitude": "-149.906851",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-562-7746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6808-70ca-bcd2-58e5527bebd9",
        "storage_key": "property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFTzvf9mXyFYRqIga6NCUha4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_ea1026ed-8c01-4d49-8d45-7e00174952c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Studio One VASIE® Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "4007 Old Seward Hwy #900, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-14bf-754a-9d70-779f44fb1390.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-14bf-754a-9d70-779f44fb1390",
        "storage_key": "property/6767906449167169/01a140b3-14bf-754a-9d70-779f44fb1390.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.vasieonline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=468324441195412692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "studio-one-vasie-pilates",
      "poi_latitude": "61.184021699999995",
      "poi_longitude": "-149.8670886",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 702-708-2743",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6808-70ca-bcd2-58e5527bebd9",
        "storage_key": "property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0w0d7yXyFYR1PwVFZnSfwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_82ebe69f-14dd-4c50-9be5-101306436239",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Evolve Yoga Llc",
      "poi_type": "Health and Wellness",
      "poi_address": "1443 W Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://yogaevolveus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11415134881614981166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "evolve-yoga-llc",
      "poi_latitude": "61.195573",
      "poi_longitude": "-149.9114979",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-561-9642",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6808-70ca-bcd2-58e5527bebd9",
        "storage_key": "property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_V-oTNmXyFYRLujU4bG0ap4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_243f343a-aab4-4bce-852b-517b8a15f7af",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Margaret Eagan Sullivan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1824 W 15th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Green space with a paved biking & walking path fronting Westchester Lagoon, plus mountain views.",
      "poi_long_description": "Green space with a paved biking & walking path fronting Westchester Lagoon, plus mountain views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-15a1-72a2-baf5-f63c0c045981.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-15a1-72a2-baf5-f63c0c045981",
        "storage_key": "property/6767906449167169/01a140b3-15a1-72a2-baf5-f63c0c045981.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10765612440412588611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "margaret-eagan-sullivan-park",
      "poi_latitude": "61.20760069999999",
      "poi_longitude": "-149.91709509999998",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6dc2-7529-b048-12bd0d89ed86",
        "storage_key": "property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUwm4bXy9yFYRQ4pR1HkjZ5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_672b2f9c-cc8e-4d18-879e-d2abe66451ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Valley of the Moon Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "610 W 17th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Tree-lined green space with a large, modern playground, dog park, hiking trails & a creek.",
      "poi_long_description": "Tree-lined green space with a large, modern playground, dog park, hiking trails & a creek.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-172d-7222-82cf-18d4c0f9e497.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-172d-7222-82cf-18d4c0f9e497",
        "storage_key": "property/6767906449167169/01a140b3-172d-7222-82cf-18d4c0f9e497.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.alaska.org/detail/valley-of-the-moon-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13618989538806419726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-of-the-moon-park",
      "poi_latitude": "61.2049461",
      "poi_longitude": "-149.89451409999998",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6dc2-7529-b048-12bd0d89ed86",
        "storage_key": "property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm0Huw9OXyFYRDlFRPNReAL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_385a9b41-0608-4588-8822-bd80c26d46eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Spenard Beach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3412 Lakeshore Dr, Anchorage, AK 99517, USA",
      "poi_short_description": "Lakeside city park offering scenic plane watching and picnic areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-1794-752e-a65a-1264c5e538c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-1794-752e-a65a-1264c5e538c3",
        "storage_key": "property/6767906449167169/01a140b3-1794-752e-a65a-1264c5e538c3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15475686973490953156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spenard-beach-park",
      "poi_latitude": "61.1801697",
      "poi_longitude": "-149.946593",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6dc2-7529-b048-12bd0d89ed86",
        "storage_key": "property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz1VU0le9yFYRxHsRBk-vxNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_95e2290d-9dd1-4ec3-b2c7-46db44cc1e35",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Balto Seppala Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3360 Wisconsin St, Anchorage, AK 99517, USA",
      "poi_short_description": "Community city park featuring a playground and expansive recreational fields.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-18aa-76be-99bf-ae938bdc25b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-18aa-76be-99bf-ae938bdc25b9",
        "storage_key": "property/6767906449167169/01a140b3-18aa-76be-99bf-ae938bdc25b9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6136051254312274303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "balto-seppala-park",
      "poi_latitude": "61.1903545",
      "poi_longitude": "-149.9441637",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6dc2-7529-b048-12bd0d89ed86",
        "storage_key": "property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06_ffv2XyFYRf4nfCBuiJ1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_5d1654d6-3cb4-441d-83a5-1f780c3cc5ba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Elderberry Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1297 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Scenic city park offering coastal trail access and sunset views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-1c19-753e-a4e6-c92f4f6474df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-1c19-753e-a4e6-c92f4f6474df",
        "storage_key": "property/6767906449167169/01a140b3-1c19-753e-a4e6-c92f4f6474df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16737905006090040660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elderberry-park",
      "poi_latitude": "61.21801979999999",
      "poi_longitude": "-149.90654139999998",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6dc2-7529-b048-12bd0d89ed86",
        "storage_key": "property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVccMwoO9yFYRVLU6_Ov7SOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_347c1689-cb6d-420a-aed6-938221fa4528",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Earthquake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5101 Point Woronzof Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "A devastating 1964 earthquake shaped this hilly area, which offers trails & an interpretive display.",
      "poi_long_description": "A devastating 1964 earthquake shaped this hilly area, which offers trails & an interpretive display.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-1fc8-764e-b234-cfbbc015c823.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-1fc8-764e-b234-cfbbc015c823",
        "storage_key": "property/6767906449167169/01a140b3-1fc8-764e-b234-cfbbc015c823.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.anchorage.net/discover/trails-and-local-parks/earthquake-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10919572690925706311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "earthquake-park",
      "poi_latitude": "61.1984068",
      "poi_longitude": "-149.98020839999998",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6dc2-7529-b048-12bd0d89ed86",
        "storage_key": "property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2AwokC9yFYRR9yuDYIdipc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_60c3ce12-4f08-41ac-844f-385f5e9ed787",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Point Woronzof Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9700 Point Woronzof Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Large wooded area with trails for hiking, running, bicycling & cross-country skiing seasonally.",
      "poi_long_description": "Large wooded area with trails for hiking, running, bicycling & cross-country skiing seasonally.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-4984-75d8-89ba-0f1efe4f9e7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-4984-75d8-89ba-0f1efe4f9e7c",
        "storage_key": "property/6767906449167169/019d0220-4984-75d8-89ba-0f1efe4f9e7c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3646899879165127207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "point-woronzof-park",
      "poi_latitude": "61.201123599999995",
      "poi_longitude": "-150.0203185",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6dc2-7529-b048-12bd0d89ed86",
        "storage_key": "property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh7F3TS29yFYRJ2oNNR5knDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_9cbdb4a0-e974-4dcf-9824-123cc74583d2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Kincaid Outdoor Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9401 Raspberry Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-1f14-738c-89cc-29a686a30e3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-1f14-738c-89cc-29a686a30e3c",
        "storage_key": "property/6767906449167169/01a140b3-1f14-738c-89cc-29a686a30e3c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/Pages/Kincaid.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4482038648302601019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kincaid-outdoor-center",
      "poi_latitude": "61.154224199999994",
      "poi_longitude": "-150.0565216",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-343-6397",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6808-70ca-bcd2-58e5527bebd9",
        "storage_key": "property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0U0ufCiyFYROwOmXWdmMz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "picnic_ground"
    },
    {
      "id": "custom_8973ef8f-8429-4713-a0d7-e3d2533ac70e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Little Campbell Lake",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8801 Raspberry Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-201d-70e6-b32b-c47871f90deb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-201d-70e6-b32b-c47871f90deb",
        "storage_key": "property/6767906449167169/01a140b3-201d-70e6-b32b-c47871f90deb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaska.org/detail/little-campbell-lake",
      "poi_directions_map_url": "https://maps.google.com/?cid=16945797376955916151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-campbell-lake",
      "poi_latitude": "61.163447000000005",
      "poi_longitude": "-150.0233833",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-3ad0-7279-8360-c371553a4e84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140b3-3ad0-7279-8360-c371553a4e84",
        "storage_key": "property/6767906449167169/01a140b3-3ad0-7279-8360-c371553a4e84.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ54VPz_CiyFYRdx80ge6QK-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ef0baa81-2625-4406-85a8-8cb8fe795eaa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "University Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4050 University Lake Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "Scenic lakeside dog park with walking trails and swimming areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-1f59-70b2-b030-2f64a53c50f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-1f59-70b2-b030-2f64a53c50f4",
        "storage_key": "property/6767906449167169/01a140b3-1f59-70b2-b030-2f64a53c50f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14589859302453206728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-lake-park",
      "poi_latitude": "61.1848311",
      "poi_longitude": "-149.8077434",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6dc2-7529-b048-12bd0d89ed86",
        "storage_key": "property/6767906449167169/019d0220-6dc2-7529-b048-12bd0d89ed86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu_rUugKXyFYRyN6mNbyXeco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_5639c2b8-db4a-4f57-a31f-9bd16ac9bd7d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Ted Stevens Anchorage International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5000 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_long_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b1-87f6-7348-85ae-9a2c18d8197c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b1-87f6-7348-85ae-9a2c18d8197c",
        "storage_key": "property/6767906449167169/01a140b1-87f6-7348-85ae-9a2c18d8197c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dot.alaska.gov/anc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10860248208626249647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ted-stevens-anchorage-international-airport",
      "poi_latitude": "61.1769173",
      "poi_longitude": "-149.9905923",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-266-2526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-72ea-7408-92bb-80f7f4da7b1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-72ea-7408-92bb-80f7f4da7b1f",
        "storage_key": "property/6767906449167169/019d0220-72ea-7408-92bb-80f7f4da7b1f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJERqXa7WiyFYRr2-9pzRat5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_f13af640-a431-44b2-8869-b39df199e425",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Bill Sheffield Alaska Railroad Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "4980 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-2656-7369-96e9-a36bfc69c7f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-2656-7369-96e9-a36bfc69c7f7",
        "storage_key": "property/6767906449167169/01a140b3-2656-7369-96e9-a36bfc69c7f7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.alaskarailroad.com/real-estate/depot-rentals",
      "poi_directions_map_url": "https://maps.google.com/?cid=17805455315424171249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bill-sheffield-alaska-railroad-depot",
      "poi_latitude": "61.1745567",
      "poi_longitude": "-149.9804143",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-265-2466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b1-9a71-71dd-9b3e-b5fa0fa71ef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140b1-9a71-71dd-9b3e-b5fa0fa71ef8",
        "storage_key": "property/6767906449167169/01a140b1-9a71-71dd-9b3e-b5fa0fa71ef8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yjDfmujyFYR8dTyo0WvGfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_65b995d9-e997-4886-94be-680db9400001",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Anchorage Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "411 W 1st Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_long_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b1-884f-74dd-88c5-a8095b27f383.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b1-884f-74dd-88c5-a8095b27f383",
        "storage_key": "property/6767906449167169/01a140b1-884f-74dd-88c5-a8095b27f383.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaskarailroad.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3741649916070368533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-depot",
      "poi_latitude": "61.2216964",
      "poi_longitude": "-149.8901898",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 800-544-0552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-72e6-77de-9466-6a3a22bddb2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-72e6-77de-9466-6a3a22bddb2c",
        "storage_key": "property/6767906449167169/019d0220-72e6-77de-9466-6a3a22bddb2c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJfd_0CYi9yFYRFZU-ScYC7TM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_1886c13c-d5d3-4290-912a-ad78f4dccd7d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Downtown Transit Center Pass",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-25a2-757a-b409-331bf0612991.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-25a2-757a-b409-331bf0612991",
        "storage_key": "property/6767906449167169/01a140b3-25a2-757a-b409-331bf0612991.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500851897172059445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-transit-center-pass",
      "poi_latitude": "61.21588799999999",
      "poi_longitude": "-149.8964133",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-343-6543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6808-70ca-bcd2-58e5527bebd9",
        "storage_key": "property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2bquYC9yFYRNWVRyd07m58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_0faac233-1c6b-4e20-868d-dd0798a7b638",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Dimond Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-26c1-7188-aa8e-338fa9e3e9b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-26c1-7188-aa8e-338fa9e3e9b7",
        "storage_key": "property/6767906449167169/01a140b3-26c1-7188-aa8e-338fa9e3e9b7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17211653549311854446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-transit-center",
      "poi_latitude": "61.142764",
      "poi_longitude": "-149.871953",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-3ad5-739f-a0e2-4a0b915e1903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140b3-3ad5-739f-a0e2-4a0b915e1903",
        "storage_key": "property/6767906449167169/01a140b3-3ad5-739f-a0e2-4a0b915e1903.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVAwvdGZyFYRbgfTO7YT3O4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_35c422fe-b468-44b7-8e44-d633e55ac8ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Downtown Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-2aaf-74e7-a27f-233f9e9cf607.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-2aaf-74e7-a27f-233f9e9cf607",
        "storage_key": "property/6767906449167169/01a140b3-2aaf-74e7-a27f-233f9e9cf607.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10208541497442915044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-transit-center",
      "poi_latitude": "61.216553000000005",
      "poi_longitude": "-149.896764",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-3ad5-739f-a0e2-4a0b915e1903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140b3-3ad5-739f-a0e2-4a0b915e1903",
        "storage_key": "property/6767906449167169/01a140b3-3ad5-739f-a0e2-4a0b915e1903.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJL9P4x4C9yFYR5FLrnWcGrI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_d9745d74-78a4-4ab6-aac4-d55b692223e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Merrill Field Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "800 Merrill Field Dr, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-cc1e-749c-8c1e-e2d3a43f942a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-cc1e-749c-8c1e-e2d3a43f942a",
        "storage_key": "property/6767906449167169/019d0220-cc1e-749c-8c1e-e2d3a43f942a.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.muni.org/Departments/merrill_field/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3690256857556359428&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merrill-field-airport",
      "poi_latitude": "61.215917",
      "poi_longitude": "-149.8419312",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-343-6303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-72ea-7408-92bb-80f7f4da7b1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-72ea-7408-92bb-80f7f4da7b1f",
        "storage_key": "property/6767906449167169/019d0220-72ea-7408-92bb-80f7f4da7b1f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJF1chpUeWyFYRBJmYZA9tNjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_304d9c4b-e92e-4440-8bd3-f4419f6ec9db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Minnesota & 26th Avenue SSW",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99517, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4578342454170736096&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minnesota--26th-avenue-ssw",
      "poi_latitude": "61.197061999999995",
      "poi_longitude": "-149.913412",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-3ad5-739f-a0e2-4a0b915e1903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140b3-3ad5-739f-a0e2-4a0b915e1903",
        "storage_key": "property/6767906449167169/01a140b3-3ad5-739f-a0e2-4a0b915e1903.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJv3yJINmXyFYR4NXveDSKiT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_a050a1b4-e575-4d83-83db-20523ba41da6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "People Mover",
      "poi_type": "Transportation & Transit",
      "poi_address": "3600 Doctor M.L.K. Jr Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-2725-7109-9260-d1b3dc5af784.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-2725-7109-9260-d1b3dc5af784",
        "storage_key": "property/6767906449167169/01a140b3-2725-7109-9260-d1b3dc5af784.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14529945198539884947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "people-mover",
      "poi_latitude": "61.177075599999995",
      "poi_longitude": "-149.8139324",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-343-8402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6808-70ca-bcd2-58e5527bebd9",
        "storage_key": "property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzSp6ChCXyFYRk8nc1Cy8pMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_f0fdb6c0-0bd8-4714-946b-2252fa4b1a64",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Alaska Native Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4315 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-3c32-7558-8256-4926ebeb2341.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-3c32-7558-8256-4926ebeb2341",
        "storage_key": "property/6767906449167169/019d0220-3c32-7558-8256-4926ebeb2341.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://anmc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12633987291157363904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-medical-center",
      "poi_latitude": "61.182452",
      "poi_longitude": "-149.80024269999998",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-563-2662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6d67-7728-8333-3392e5a2e24e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6d67-7728-8333-3392e5a2e24e",
        "storage_key": "property/6767906449167169/019d0220-6d67-7728-8333-3392e5a2e24e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_bUZRyXyFYRwPw76oDwVK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_42c59b21-e6d3-43fe-bae8-12ef46d5f073",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Southcentral Foundation Nu ch’ghednu Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Southcentral Foundation Administration Building, 4501 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-2abc-74f3-ace0-eb3b3d3691d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-2abc-74f3-ace0-eb3b3d3691d2",
        "storage_key": "property/6767906449167169/01a140b3-2abc-74f3-ace0-eb3b3d3691d2.webp",
        "width": 1022,
        "height": 1280
      },
      "poi_business_url": "https://www.southcentralfoundation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17022574653971337258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southcentral-foundation-nu-chghednu-building",
      "poi_latitude": "61.18234169999999",
      "poi_longitude": "-149.79589199999998",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-729-4955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6808-70ca-bcd2-58e5527bebd9",
        "storage_key": "property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJYTXMhyXyFYRKpCHVHVVPOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_679df4a0-91eb-45e4-abd2-1bba2c65dc5f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Alaska Native Tribal Health Consortium",
      "poi_type": "Health and Wellness",
      "poi_address": "4000 Ambassador Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-2d75-762d-ae25-95e95e465893.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-2d75-762d-ae25-95e95e465893",
        "storage_key": "property/6767906449167169/01a140b3-2d75-762d-ae25-95e95e465893.webp",
        "width": 1280,
        "height": 301
      },
      "poi_business_url": "http://www.anthc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1002423738872135572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-tribal-health-consortium",
      "poi_latitude": "61.184003999999995",
      "poi_longitude": "-149.7994651",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-729-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6d67-7728-8333-3392e5a2e24e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6d67-7728-8333-3392e5a2e24e",
        "storage_key": "property/6767906449167169/019d0220-6d67-7728-8333-3392e5a2e24e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ7c0qhyXyFYRlH_kVRRT6Q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_92a8f8c2-8dfb-4bb1-a2d3-f664de826460",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "ConocoPhillips Alaska",
      "poi_type": "Major Employers & Offices",
      "poi_address": "700 G St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-309c-758d-8011-d2645cf8dd20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-309c-758d-8011-d2645cf8dd20",
        "storage_key": "property/6767906449167169/01a140b3-309c-758d-8011-d2645cf8dd20.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://alaska.conocophillips.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18204751589556885795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conocophillips-alaska",
      "poi_latitude": "61.215194",
      "poi_longitude": "-149.8962402",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-276-1215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-6808-70ca-bcd2-58e5527bebd9",
        "storage_key": "property/6767906449167169/019d0220-6808-70ca-bcd2-58e5527bebd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9x13m4C9yFYRIxnEJx5FpPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d6915247-0996-44cb-822c-043903556425",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Anchorage School District",
      "poi_type": "Education",
      "poi_address": "5530 E Northern Lights Blvd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b3-3105-70d9-8488-bc1c92372d87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b3-3105-70d9-8488-bc1c92372d87",
        "storage_key": "property/6767906449167169/01a140b3-3105-70d9-8488-bc1c92372d87.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11253021771947721235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-school-district",
      "poi_latitude": "61.193963100000005",
      "poi_longitude": "-149.7754994",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-742-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-686b-74ad-a469-dbcca425a008",
        "storage_key": "property/6767906449167169/019d0220-686b-74ad-a469-dbcca425a008.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc3ueb-mWyFYRE0KuNq7DKpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_02807407-c73e-4f09-8286-60cbe52e7bd1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "custom",
      "poi_name": "Anchorage City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "632 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/01a140b1-8dd5-7088-b14a-62756c957dd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140b1-8dd5-7088-b14a-62756c957dd7",
        "storage_key": "property/6767906449167169/01a140b1-8dd5-7088-b14a-62756c957dd7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1064156177697528647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-city-hall",
      "poi_latitude": "61.216329900000005",
      "poi_longitude": "-149.8948221",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-343-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d0220-72e8-726f-bd48-fcbd49bb7076.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-72e8-726f-bd48-fcbd49bb7076",
        "storage_key": "property/6767906449167169/019d0220-72e8-726f-bd48-fcbd49bb7076.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDkroC9yFYRR9syzWekxA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_712b991205f3c66664a8e8b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7dd96f5416318f6ac5c429c0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_451fec46f16da7db973ac536",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a7536f0f0ae8438a314b553d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7aed874e78cfe23aa82923f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_634e0c8b-4a50-4455-b1bf-6a7f9c551d93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "rating": "5.0",
      "name": "Cameron Warner",
      "text": "My family and I have loved Arbor Pointe. The location is convenient, the staff is helpful, the maintenance is prompt, the apartments are spacious and cozy, the community is peaceful and friendly, and the pet policy is accommodating. The rent is affordable and the incentives are attractive. I rate it 5 stars and suggest it to anyone.",
      "date": "2023-06-21",
      "title": ""
    },
    {
      "id": "custom_14871716-cf06-4b54-97d9-6d76c0b8c7e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "rating": "5.0",
      "name": "Ray Legacy",
      "text": "Mary Christensen is so amazing! I'm super grateful to have her here as her smile is super inviting to all the residents here! Any leasing office she runs is always a more friendlier space because of her!",
      "date": "2024-06-06",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_d70f83f80ad06b95a1e82fa1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019ddcf7-ee44-701d-b153-9bcc1ca5da14.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf7-ee44-701d-b153-9bcc1ca5da14",
        "storage_key": "property/6767906449167169/019ddcf7-ee44-701d-b153-9bcc1ca5da14.webp",
        "width": 295,
        "height": 166
      },
      "virtual_tour_title": "Studio",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/407403458"
    },
    {
      "id": "ec_0ebb040011d228dc29504531",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019ddcf7-ee58-718b-b73d-a4dcc592854b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf7-ee58-718b-b73d-a4dcc592854b",
        "storage_key": "property/6767906449167169/019ddcf7-ee58-718b-b73d-a4dcc592854b.webp",
        "width": 295,
        "height": 166
      },
      "virtual_tour_title": "One Bedroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/407402601"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-d0ba-7510-8b36-ebffa470f540",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Arbor Pointe Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "generator",
      "page_item_url": "apartments-on-site-laundry-facility-anchorage",
      "search_query": "apartments with on-site laundry facility in Anchorage",
      "category": "Amenity",
      "h1_title": "Apartments with On-Site Laundry in Anchorage",
      "h2_subtitle": "Discover convenience with apartments offering on-site laundry facilities in Anchorage, making daily life simpler at Arbor Pointe.",
      "page_copy": "Finding a convenient place to live in Anchorage is easy at Arbor Pointe, where you can enjoy the luxury of an on-site laundry facility. This practical amenity ensures you never have to travel far to wash clothes, enhancing your lifestyle with comfort and efficiency. \n\nSituated in the charming North Star neighborhood, Arbor Pointe provides more than just a convenient on-site laundry facility. Residents appreciate the energy-efficient appliances and the comfort of a private patio or balcony. With an attentive on-site management team, you’ll feel right at home in this welcoming community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with On-Site Laundry in Anchorage",
      "seo_description": "Discover Arbor Pointe, where on-site laundry facilities and more provide convenience in Anchorage. Live comfortably!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "generator",
      "page_item_url": "energy-efficient-appliance-apartments-anchorage",
      "search_query": "energy-efficient apartment appliances in Anchorage Municipality",
      "category": "Amenity",
      "h1_title": "Energy-Efficient Apartment Appliances",
      "h2_subtitle": "Explore Arbor Pointe in Anchorage Municipality, where every apartment boasts energy-efficient appliances to enhance sustainable living.",
      "page_copy": "At Arbor Pointe, located in the heart of Anchorage Municipality, sustainable living is a top priority. Each apartment is designed with energy-efficient appliances, reducing your carbon footprint while lowering utility bills. These features ensure that your home is both economical and environmentally friendly.\n\nBeyond the benefits of energy-efficient appliances, Arbor Pointe offers a host of other amenities. Enjoy a private patio or balcony, perfect for relaxing and enjoying the scenic views of North Star. The on-site management team is dedicated to meeting residents' needs, making Arbor Pointe one of the most sought-after communities in Anchorage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy-Efficient Apartment Appliances in Anchorage",
      "seo_description": "Live sustainably at Arbor Pointe with energy-efficient appliances in Anchorage Municipality. Eco-friendly living awaits!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "generator",
      "page_item_url": "private-balcony-apartments-north-star-anchorage",
      "search_query": "apartments with private balcony in North Star Anchorage",
      "category": "Amenity",
      "h1_title": "Apartments with Private Balcony in North Star",
      "h2_subtitle": "Experience the charm of North Star Anchorage with apartments featuring private balconies at Arbor Pointe.",
      "page_copy": "Nestled in the peaceful neighborhood of North Star, Arbor Pointe offers apartments with private balconies, providing a perfect retreat right at home. These personal outdoor spaces are ideal for enjoying the fresh Alaskan air or simply relaxing with a good book while taking in scenic views.\n\nArbor Pointe combines the best of indoor and outdoor living with energy-efficient appliances and a dedicated on-site management team to enhance your living experience. Residents also benefit from other convenient amenities including an on-site laundry facility, making Arbor Pointe a standout choice in Anchorage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Private Balcony in North Star",
      "seo_description": "Discover Arbor Pointe in North Star Anchorage, where private balconies offer outdoor relaxation and comfort. Experience it today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "generator",
      "page_item_url": "bike-storage-apartments-anchorage-ak",
      "search_query": "bike storage apartments in Anchorage AK",
      "category": "Amenity",
      "h1_title": "Bike Storage Apartments in Anchorage AK",
      "h2_subtitle": "Discover Anchorage's Arbor Pointe, where thoughtful amenities like bike storage make your active lifestyle easy and convenient.",
      "page_copy": "At Arbor Pointe, we understand the importance of catering to active lifestyles. That's why our Anchorage, AK apartments offer practical amenities like dedicated bike storage. Whether you're commuting through the vibrant streets or exploring the scenic trails of North Star, secure bike storage makes life easier and more organized.\n\nIn addition to bike storage, Arbor Pointe features energy-efficient appliances and private balconies that enhance your residential experience. The on-site management team is always ready to assist, ensuring a welcoming environment and a pleasant living experience in Anchorage Municipality.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bike Storage Apartments in Anchorage AK",
      "seo_description": "Find bike storage apartments at Arbor Pointe Anchorage, AK. Ideal for active lifestyles with convenience in North Star.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "generator",
      "page_item_url": "onsite-management-team-apartments-99503",
      "search_query": "convenient on-site management team in 99503",
      "category": "Amenity",
      "h1_title": "Convenient On-Site Management in 99503",
      "h2_subtitle": "Arbor Pointe Apartments in Anchorage 99503 offer a dedicated on-site management team ready to meet residents' needs efficiently.",
      "page_copy": "Located in the vibrant area of Anchorage 99503, Arbor Pointe Apartments pride themselves on offering a seamless living experience with a convenient on-site management team. Whether you need assistance with maintenance or have community questions, our dedicated team is always ready to ensure your needs are met promptly and efficiently.\n\nArbor Pointe not only provides exceptional on-site management but also boasts a range of amenities designed with residents in mind. Enjoy energy-efficient appliances, a private patio or balcony, and easy access to laundry facilities, making it a lifestyle choice you will love.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient On-Site Management in 99503",
      "seo_description": "Live at Arbor Pointe 99503, where our on-site management team is always ready to assist you, providing service tailored to your needs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "generator",
      "page_item_url": "studio-apartments-anchorage-ak",
      "search_query": "studio apartments Anchorage AK",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Anchorage AK",
      "h2_subtitle": "Arbor Pointe offers cozy studio apartments in the heart of Anchorage, AK, with amenities that enhance your living experience.",
      "page_copy": "Discover the perfect balance of comfort and convenience with our studio apartments at Arbor Pointe in Anchorage, AK. Designed for modern living, these studios offer a cozy yet functional space that's ideal for those seeking simplicity without compromising on amenities.\n\nArbor Pointe is equipped with energy-efficient appliances to help you save on utility bills while enjoying a sustainable lifestyle. Residents also enjoy the perks of a private patio or balcony, allowing you to unwind in peace. Located in North Star, these studios are part of a vibrant community where the dedicated on-site management team is always ready to assist.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Anchorage AK",
      "seo_description": "Explore Arbor Pointe studio apartments in Anchorage AK. Enjoy modern amenities in a vibrant community. Perfect for simple, efficient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-north-star-anchorage",
      "search_query": "one bedroom apartments North Star Anchorage",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in North Star, Anchorage",
      "h2_subtitle": "Choose Arbor Pointe for spacious one bedroom apartments nestled in the welcoming North Star area of Anchorage.",
      "page_copy": "Arbor Pointe is the ideal destination for those seeking one bedroom apartments in the charming North Star neighborhood of Anchorage. Our thoughtfully designed spaces feature energy-efficient appliances and a private patio or balcony, providing residents with both comfort and modern conveniences.\n\nLiving in North Star means you're part of a vibrant community. Arbor Pointe enhances this experience by offering a responsive on-site management team, ready to address your needs promptly. Additional amenities include an on-site laundry facility, making daily routines effortless and enjoyable. Experience Anchorage living at its best in our one bedroom apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments North Star Anchorage",
      "seo_description": "Discover Arbor Pointe's one bedroom apartments in North Star, Anchorage. Enjoy spacious living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "generator",
      "page_item_url": "apartments-near-university-alaska-anchorage",
      "search_query": "apartments near university of alaska anchorage north star",
      "category": "School",
      "h1_title": "Apartments Near University of Alaska Anchorage",
      "h2_subtitle": "Find your home at Arbor Pointe, offering apartments near the University of Alaska Anchorage, in the vibrant North Star neighborhood.",
      "page_copy": "Arbor Pointe stands out as a top choice for students and professionals seeking apartments near the University of Alaska Anchorage. Located in the lively North Star area, our community provides easy access to the university while offering a range of amenities.\n\nOur energy-efficient spaces come with modern conveniences such as private patios or balconies and an on-site laundry facility. With a dedicated on-site management team always available, residents enjoy a seamless living experience. Choose Arbor Pointe and embrace the comfort and convenience of living near one of Alaska's top educational institutions.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Alaska Anchorage",
      "seo_description": "Explore Arbor Pointe, conveniently located near the University of Alaska Anchorage in North Star, offering modern living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "generator",
      "page_item_url": "apartments-near-alaska-native-medical-center",
      "search_query": "apartments near Alaska Native Medical Center Anchorage",
      "category": "Hospital",
      "h1_title": "Apartments Near Alaska Native Medical Center",
      "h2_subtitle": "Discover Arbor Pointe, ideally located near the Alaska Native Medical Center in Anchorage, offering convenience and modern amenities.",
      "page_copy": "Situated conveniently near the Alaska Native Medical Center, Arbor Pointe provides an excellent choice for those seeking apartments in Anchorage. Our community prioritizes a comfortable and convenient lifestyle, perfect for medical professionals and families alike.\n\nOffering energy-efficient appliances and spacious layouts with private patios or balconies, Arbor Pointe ensures residents enjoy modern amenities. An on-site management team and laundry facility add to the ease of living here. Situated in a vibrant neighborhood, Arbor Pointe balances accessibility and tranquility, making it a desirable option near the Alaska Native Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alaska Native Medical Center",
      "seo_description": "Find Arbor Pointe apartments near Alaska Native Medical Center in Anchorage. Enjoy comfort and convenience with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "generator",
      "page_item_url": "apartments-close-to-providence-alaska-medical-center",
      "search_query": "apartments close to Providence Alaska Medical Center North Star",
      "category": "Hospital",
      "h1_title": "Apartments Near Providence Alaska Medical Center",
      "h2_subtitle": "Explore Arbor Pointe, offering apartments close to Providence Alaska Medical Center, located in North Star, Anchorage.",
      "page_copy": "Arbor Pointe is an ideal community for those seeking apartments close to Providence Alaska Medical Center. Located in the North Star neighborhood, our apartments offer the perfect balance of accessibility and modern living.\n\nEach apartment features energy-efficient appliances and spacious designs with private patios or balconies that enhance comfort. Our on-site management team and laundry facilities ensure a seamless living experience. Nestle yourself in the vibrant North Star vicinity while staying near Providence Alaska Medical Center, making Arbor Pointe a preferred option in Anchorage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Providence Alaska Medical Center",
      "seo_description": "Discover Arbor Pointe's convenient apartments near Providence Alaska Medical Center in North Star, Anchorage, featuring modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "generator",
      "page_item_url": "apartments-near-kincaid-park-anchorage",
      "search_query": "apartments near kincaid park anchorage",
      "category": "Park",
      "h1_title": "Apartments Near Kincaid Park Anchorage",
      "h2_subtitle": "Live close to nature at Arbor Pointe, offering apartments near Kincaid Park in Anchorage, where comfort meets convenience.",
      "page_copy": "Arbor Pointe offers a serene living experience with apartments near Kincaid Park in Anchorage. Perfect for outdoor enthusiasts, our location provides easy access to the park's extensive trails and natural beauty, ideal for biking, hiking, and exploring the outdoors.\n\nOur community boasts energy-efficient appliances, spacious layouts with private patios or balconies, and a supportive on-site management team ready to assist. With an on-site laundry facility, Arbor Pointe ensures hassle-free living. Embrace a lifestyle that combines nature’s doorstep with modern convenience near Kincaid Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kincaid Park Anchorage",
      "seo_description": "Experience Arbor Pointe's relaxed living near Kincaid Park in Anchorage. Enjoy proximity to nature and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "generator",
      "page_item_url": "north-star-apartments-close-to-earthquake-park",
      "search_query": "north star apartments close to earthquake park",
      "category": "Park",
      "h1_title": "North Star Apartments Near Earthquake Park",
      "h2_subtitle": "Discover Arbor Pointe, offering North Star apartments close to Earthquake Park in Anchorage, with unbeatable access to nature and city life.",
      "page_copy": "Arbor Pointe, situated in Anchorage's North Star neighborhood, provides the perfect blend of accessibility and comfort. Our apartments are conveniently located close to Earthquake Park, allowing easy exploration of its scenic trails and stunning views.\n\nAt Arbor Pointe, enjoy energy-efficient appliances, private patios or balconies, and a dedicated on-site management team, ensuring comfort and convenience. An on-site laundry facility adds further ease to daily life. Experience the vibrant North Star community coupled with easy access to Earthquake Park, making Arbor Pointe an excellent choice for those who value both city and nature.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "North Star Apartments Near Earthquake Park",
      "seo_description": "Experience Arbor Pointe in North Star, with modern amenities and proximity to Earthquake Park, ideal for nature lovers and city dwellers in Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "generator",
      "page_item_url": "arbor-pointe-apartments-near-alaska-botanical-garden",
      "search_query": "arbor pointe apartments near alaska botanical garden",
      "category": "Park",
      "h1_title": "Arbor Pointe Near Alaska Botanical Garden",
      "h2_subtitle": "Live at Arbor Pointe, ideally situated near the Alaska Botanical Garden in Anchorage, combining nature with modern comfort.",
      "page_copy": "Nestled in Anchorage, Arbor Pointe offers a unique blend of natural beauty and modern living, being conveniently located near the Alaska Botanical Garden. Residents can enjoy strolling through the lush gardens and peaceful landscapes whenever they desire.\n\nOur apartments feature energy-efficient appliances and spacious designs that include private patios or balconies perfect for relaxation. With an on-site management team to assist and a laundry facility on the property, we ensure a comfortable living environment. Experience the joy of living next to the Alaska Botanical Garden at Arbor Pointe.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Arbor Pointe Near Alaska Botanical Garden",
      "seo_description": "Discover Arbor Pointe apartments with modern amenities near the Alaska Botanical Garden in Anchorage, perfect for nature enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "generator",
      "page_item_url": "delaney-park-nearby-anchorage-apartments",
      "search_query": "delaney park nearby anchorage apartments",
      "category": "Park",
      "h1_title": "Delaney Park Nearby Anchorage Apartments",
      "h2_subtitle": "Discover Arbor Pointe, offering comfortable Anchorage apartments near Delaney Park, where urban living meets serene surroundings.",
      "page_copy": "Arbor Pointe boasts a prime location with Anchorage apartments just a short distance from Delaney Park. Enjoy the convenience of urban living with the park's green oasis, ideal for relaxation and outdoor activities, right at your doorstep.\n\nOur community is equipped with energy-efficient appliances, private patios or balconies, and a responsive on-site management team ensuring a comfortable living experience. An on-site laundry facility also adds to resident convenience. Choose Arbor Pointe for a harmonious balance of city life and nearby nature with Delaney Park just minutes away.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Delaney Park Nearby Anchorage Apartments",
      "seo_description": "Experience Arbor Pointe, offering convenient Anchorage living near Delaney Park. Enjoy modern comforts and park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167169",
      "source": "generator",
      "page_item_url": "apartments-near-ted-stevens-international-airport",
      "search_query": "apartments near ted stevens international airport anchorage ak",
      "category": "Transit",
      "h1_title": "Apartments Near Ted Stevens International Airport",
      "h2_subtitle": "Find Arbor Pointe Apartments near Ted Stevens International Airport in Anchorage, AK, offering convenience and comfort for frequent travelers.",
      "page_copy": "Arbor Pointe offers the ultimate convenience for travelers, with its location near Ted Stevens International Airport in Anchorage, AK. Whether for business or leisure, residents can enjoy quick access to the airport.\n\nOur community features energy-efficient appliances, private patios or balconies for relaxation, and an attentive on-site management team. Additionally, the on-site laundry facility ensures everyday ease. Choose Arbor Pointe for a harmonious blend of modern amenities and proximity to Anchorage's main airport.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ted Stevens International Airport",
      "seo_description": "Discover Arbor Pointe apartments in Anchorage, AK, just minutes from Ted Stevens International Airport, perfect for frequent travelers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309343199"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073082998"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/5fbd08ab-b822-4cd2-97ab-70fc00e3308e/app.js?property=5fbd08ab-b822-4cd2-97ab-70fc00e3308e&propertyName=Arbor+Pointe&channelUuid=c248fef4-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47758582553"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkdCMUdReGF0RTYvb05iZnB4QmFlemc9PSIsInZhbHVlIjoiQ1AxcThrcng5QjZER2pwaTErSkRQdz09IiwibWFjIjoiOTc4MjcxMjJiZWQxYmI5ZmQxZjQyYmU4ZDI5ZGIyODg3YzM3ZDA3ZjY5YTVlMWEzYjJjNGRlMzk3MDk2Njk4ZCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309343199",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073082998",
  "custom_rollout_phase": "Phase 8",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/5fbd08ab-b822-4cd2-97ab-70fc00e3308e/app.js?property=5fbd08ab-b822-4cd2-97ab-70fc00e3308e&propertyName=Arbor+Pointe&channelUuid=c248fef4-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47758582553",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkdCMUdReGF0RTYvb05iZnB4QmFlemc9PSIsInZhbHVlIjoiQ1AxcThrcng5QjZER2pwaTErSkRQdz09IiwibWFjIjoiOTc4MjcxMjJiZWQxYmI5ZmQxZjQyYmU4ZDI5ZGIyODg3YzM3ZDA3ZjY5YTVlMWEzYjJjNGRlMzk3MDk2Njk4ZCJ9",
  "custom_audioeye_site_id": "bb87ab81-0fb7-4b36-91e4-616254adb4d5",
  "custom_audioeye_site_hash": "fa33e61e3313820a62a25fb1979d328c"
};

export const generatedAt = '2026-11-02T18:11:50.327Z';
